/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root.tsx'
import { Route as SecuredRouteImport } from './routes/_secured.tsx'
import { Route as LegalRouteImport } from './routes/_legal.tsx'
import { Route as AuthRouteImport } from './routes/_auth.tsx'
import { Route as IndexRouteImport } from './routes/index.tsx'
import { Route as SecuredTestigosRouteImport } from './routes/_secured/testigos.tsx'
import { Route as SecuredReportingRouteImport } from './routes/_secured/reporting.tsx'
import { Route as SecuredInsightsRouteImport } from './routes/_secured/insights.tsx'
import { Route as SecuredExternalDataRouteImport } from './routes/_secured/external-data.tsx'
import { Route as SecuredCompanyProfileRouteImport } from './routes/_secured/company-profile.tsx'
import { Route as SecuredAiHubRouteImport } from './routes/_secured/ai-hub.tsx'
import { Route as SecuredAgencyHubRouteImport } from './routes/_secured/agency-hub.tsx'
import { Route as SecuredTestigosIndexRouteImport } from './routes/_secured/testigos/index.tsx'
import { Route as SecuredReportingIndexRouteImport } from './routes/_secured/reporting/index.tsx'
import { Route as SecuredNotificationsIndexRouteImport } from './routes/_secured/notifications/index.tsx'
import { Route as SecuredExternalDataIndexRouteImport } from './routes/_secured/external-data/index.tsx'
import { Route as SecuredCompanyProfileIndexRouteImport } from './routes/_secured/company-profile/index.tsx'
import { Route as SecuredCampaignsIndexRouteImport } from './routes/_secured/campaigns/index.tsx'
import { Route as SecuredAiHubIndexRouteImport } from './routes/_secured/ai-hub/index.tsx'
import { Route as AuthWorkspacesIndexRouteImport } from './routes/_auth/workspaces/index.tsx'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index.tsx'
import { Route as AuthLoginAuth0IndexRouteImport } from './routes/_auth/login-auth0/index.tsx'
import { Route as AuthExpiredLinkIndexRouteImport } from './routes/_auth/expired-link/index.tsx'
import { Route as SecuredExternalDataIntegrationsRouteImport } from './routes/_secured/external-data/integrations.tsx'
import { Route as SecuredExternalDataImportHubRouteImport } from './routes/_secured/external-data/import-hub.tsx'
import { Route as SecuredCompanyProfileValuesManagerRouteImport } from './routes/_secured/company-profile/values-manager.ts'
import { Route as SecuredCompanyProfileUsersManagementRouteImport } from './routes/_secured/company-profile/users-management.tsx'
import { Route as SecuredCompanyProfileUserActivitiesRouteImport } from './routes/_secured/company-profile/user-activities.tsx'
import { Route as SecuredCompanyProfileNamingConventionRouteImport } from './routes/_secured/company-profile/naming-convention.tsx'
import { Route as SecuredCompanyProfileMetricsManagerRouteImport } from './routes/_secured/company-profile/metrics-manager.ts'
import { Route as SecuredCompanyProfileIntegrationsRouteImport } from './routes/_secured/company-profile/integrations.tsx'
import { Route as SecuredCompanyProfileImportHubRouteImport } from './routes/_secured/company-profile/import-hub.tsx'
import { Route as SecuredCompanyProfileFlowsRouteImport } from './routes/_secured/company-profile/flows.tsx'
import { Route as SecuredCampaignCampaignIdRouteImport } from './routes/_secured/campaign/$campaignId.tsx'
import { Route as SecuredAgencyHubUsersManagementRouteImport } from './routes/_secured/agency-hub/users-management.tsx'
import { Route as SecuredReportingDataExplorationIndexRouteImport } from './routes/_secured/reporting/data-exploration/index.ts'
import { Route as SecuredExternalDataIntegrationsIndexRouteImport } from './routes/_secured/external-data/integrations/index.tsx'
import { Route as SecuredCompanyProfileUsersManagementIndexRouteImport } from './routes/_secured/company-profile/users-management/index.tsx'
import { Route as SecuredCompanyProfileUserActivitiesIndexRouteImport } from './routes/_secured/company-profile/user-activities/index.tsx'
import { Route as SecuredCompanyProfileCurrenciesIndexRouteImport } from './routes/_secured/company-profile/currencies/index.tsx'
import { Route as SecuredCompanyProfileBrandsIndexRouteImport } from './routes/_secured/company-profile/brands/index.tsx'
import { Route as SecuredCompanyProfileAdvertisersIndexRouteImport } from './routes/_secured/company-profile/advertisers/index.tsx'
import { Route as SecuredAiHubChatIdIndexRouteImport } from './routes/_secured/ai-hub/$chatId/index.tsx'
import { Route as SecuredAgencyHubUsersManagementIndexRouteImport } from './routes/_secured/agency-hub/users-management/index.tsx'
import { Route as SecuredAgencyHubClientsIndexRouteImport } from './routes/_secured/agency-hub/clients/index.tsx'
import { Route as SecuredExternalDataImportHubWhitelistedEmailsRouteImport } from './routes/_secured/external-data/import-hub/whitelisted-emails.tsx'
import { Route as SecuredExternalDataImportHubCustomMetricsRouteImport } from './routes/_secured/external-data/import-hub/custom-metrics.tsx'
import { Route as SecuredCompanyProfileNamingConventionNewRouteImport } from './routes/_secured/company-profile/naming-convention/new.tsx'
import { Route as SecuredCampaignCampaignIdTraffickingRouteImport } from './routes/_secured/campaign/$campaignId/trafficking.ts'
import { Route as SecuredCampaignCampaignIdStrategyRouteImport } from './routes/_secured/campaign/$campaignId/strategy.tsx'
import { Route as SecuredReportingDashboardsBoardIdIndexRouteImport } from './routes/_secured/reporting/dashboards/$boardId/index.tsx'
import { Route as SecuredExternalDataImportHubPerformanceIndexRouteImport } from './routes/_secured/external-data/import-hub/performance/index.tsx'
import { Route as SecuredCompanyProfileUsersManagementUserIndexRouteImport } from './routes/_secured/company-profile/users-management/user/index.tsx'
import { Route as SecuredCompanyProfileFlowsNewFlowIndexRouteImport } from './routes/_secured/company-profile/flows/new-flow/index.tsx'
import { Route as SecuredCampaignCampaignIdTraffickingIndexRouteImport } from './routes/_secured/campaign/$campaignId/trafficking/index.tsx'
import { Route as SecuredCampaignCampaignIdSettingsIndexRouteImport } from './routes/_secured/campaign/$campaignId/settings/index.tsx'
import { Route as SecuredCampaignCampaignIdPlanningIndexRouteImport } from './routes/_secured/campaign/$campaignId/planning/index.tsx'
import { Route as SecuredAgencyHubUsersManagementUserIndexRouteImport } from './routes/_secured/agency-hub/users-management/user/index.tsx'
import { Route as SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRouteImport } from './routes/_secured/external-data/integrations/$integration/suggestion-emails.tsx'
import { Route as SecuredExternalDataIntegrationsIntegrationConnectionsRouteImport } from './routes/_secured/external-data/integrations/$integration/connections.tsx'
import { Route as SecuredExternalDataIntegrationsIntegrationTabNameRouteImport } from './routes/_secured/external-data/integrations/$integration/$tabName.tsx'
import { Route as SecuredCampaignCampaignIdPlanningInsertionOrdersRouteImport } from './routes/_secured/campaign/$campaignId/planning/insertion-orders.ts'
import { Route as SecuredCampaignCampaignIdPlanningBuyingPlanRouteImport } from './routes/_secured/campaign/$campaignId/planning/buying-plan.ts'
import { Route as SecuredCampaignCampaignIdTraffickingAnalyticsIndexRouteImport } from './routes/_secured/campaign/$campaignId/trafficking/analytics/index.tsx'
import { Route as SecuredExternalDataIntegrationsIntegrationConnectionsAddRouteImport } from './routes/_secured/external-data/integrations/$integration/connections/add.tsx'
import { Route as SecuredExternalDataImportHubPerformanceImportsNewRouteImport } from './routes/_secured/external-data/import-hub/performance/imports/new.tsx'
import { Route as SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteImport } from './routes/_secured/external-data/import-hub/performance/imports/$dataFileId.tsx'
import { Route as SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRouteImport } from './routes/_secured/external-data/integrations/$integration/$tabName/$type/index.tsx'
import { Route as SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRouteImport } from './routes/_secured/external-data/integrations/$integration/connections/$connection/update.tsx'
import { Route as SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRouteImport } from './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/validation.tsx'
import { Route as SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRouteImport } from './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/headers-mapping.tsx'
import { Route as SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRouteImport } from './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/header-selection.tsx'
import { Route as SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRouteImport } from './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment.tsx'
import { Route as SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteImport } from './routes/_secured/campaign/$campaignId/settings/omni/$platform/$tileId.tsx'
import { Route as SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRouteImport } from './routes/_secured/campaign/$campaignId/settings/ghost/$tileId/settings/index.ts'
import { Route as SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRouteImport } from './routes/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/settings.tsx'
import { Route as SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRouteImport } from './routes/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/import.tsx'

const SecuredCampaignIndexLazyRouteImport = createFileRoute(
  '/_secured/campaign/',
)()
const SecuredAgencyHubIndexLazyRouteImport = createFileRoute(
  '/_secured/agency-hub/',
)()
const LegalPrivacyPolicyIndexLazyRouteImport = createFileRoute(
  '/_legal/privacy-policy/',
)()
const SecuredReportingDashboardsLazyRouteImport = createFileRoute(
  '/_secured/reporting/dashboards',
)()
const SecuredReportingDashboardsIndexLazyRouteImport = createFileRoute(
  '/_secured/reporting/dashboards/',
)()
const SecuredExternalDataImportHubIndexLazyRouteImport = createFileRoute(
  '/_secured/external-data/import-hub/',
)()
const SecuredCompanyProfileValuesManagerIndexLazyRouteImport = createFileRoute(
  '/_secured/company-profile/values-manager/',
)()
const SecuredCompanyProfileMetricsManagerIndexLazyRouteImport = createFileRoute(
  '/_secured/company-profile/metrics-manager/',
)()
const SecuredCompanyProfileFlowsIndexLazyRouteImport = createFileRoute(
  '/_secured/company-profile/flows/',
)()
const SecuredCompanyProfileCompanyInfoIndexLazyRouteImport = createFileRoute(
  '/_secured/company-profile/company-info/',
)()
const SecuredCompanyProfileClientsIndexLazyRouteImport = createFileRoute(
  '/_secured/company-profile/clients/',
)()
const SecuredAgencyHubAgencyInfoIndexLazyRouteImport = createFileRoute(
  '/_secured/agency-hub/agency-info/',
)()
const SecuredCompanyProfileNamingConventionIdLazyRouteImport = createFileRoute(
  '/_secured/company-profile/naming-convention/$id',
)()
const SecuredCampaignCampaignIdSettingsLazyRouteImport = createFileRoute(
  '/_secured/campaign/$campaignId/settings',
)()
const SecuredCompanyProfileUsersManagementRoleIndexLazyRouteImport =
  createFileRoute('/_secured/company-profile/users-management/role/')()
const SecuredCompanyProfileUserActivitiesUserViewIndexLazyRouteImport =
  createFileRoute('/_secured/company-profile/user-activities/user-view/')()
const SecuredCompanyProfileUserActivitiesActionViewIndexLazyRouteImport =
  createFileRoute('/_secured/company-profile/user-activities/action-view/')()
const SecuredCompanyProfileFlowsFlowIdIndexLazyRouteImport = createFileRoute(
  '/_secured/company-profile/flows/$flowId/',
)()
const SecuredAgencyHubUsersManagementRoleIndexLazyRouteImport = createFileRoute(
  '/_secured/agency-hub/users-management/role/',
)()
const SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRouteImport =
  createFileRoute(
    '/_secured/external-data/integrations/$integration/$tabName/',
  )()
const SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRouteImport =
  createFileRoute('/_secured/company-profile/flows/$flowId/update/')()
const SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRouteImport =
  createFileRoute('/_secured/campaign/$campaignId/strategy/campaign-info/')()
const SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRouteImport =
  createFileRoute(
    '/_secured/campaign/$campaignId/strategy/campaign-description/',
  )()
const SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRouteImport =
  createFileRoute('/_secured/campaign/$campaignId/planning/insertion-orders/')()
const SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRouteImport =
  createFileRoute('/_secured/campaign/$campaignId/planning/buying-plan/')()
const SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRouteImport =
  createFileRoute(
    '/_secured/campaign/$campaignId/strategy/mediamix/$mediaMixName',
  )()
const SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteImport =
  createFileRoute('/_secured/campaign/$campaignId/settings/omni/$platform')()
const SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRouteImport =
  createFileRoute(
    '/_secured/campaign/$campaignId/planning/insertion-orders/$id/',
  )()
const SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRouteImport =
  createFileRoute(
    '/_secured/external-data/import-hub/performance/imports/$dataFileId/upload',
  )()

const SecuredRoute = SecuredRouteImport.update({
  id: '/_secured',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_secured.lazy.tsx').then((d) => d.Route))
const LegalRoute = LegalRouteImport.update({
  id: '/_legal',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_legal.lazy.tsx').then((d) => d.Route))
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_auth.lazy.tsx').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecuredTestigosRoute = SecuredTestigosRouteImport.update({
  id: '/testigos',
  path: '/testigos',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/testigos.lazy.tsx').then((d) => d.Route),
)
const SecuredReportingRoute = SecuredReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/reporting.lazy.tsx').then((d) => d.Route),
)
const SecuredInsightsRoute = SecuredInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => SecuredRoute,
} as any)
const SecuredExternalDataRoute = SecuredExternalDataRouteImport.update({
  id: '/external-data',
  path: '/external-data',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/external-data.lazy.tsx').then((d) => d.Route),
)
const SecuredCompanyProfileRoute = SecuredCompanyProfileRouteImport.update({
  id: '/company-profile',
  path: '/company-profile',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/company-profile.lazy.tsx').then((d) => d.Route),
)
const SecuredAiHubRoute = SecuredAiHubRouteImport.update({
  id: '/ai-hub',
  path: '/ai-hub',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/ai-hub.lazy.tsx').then((d) => d.Route),
)
const SecuredAgencyHubRoute = SecuredAgencyHubRouteImport.update({
  id: '/agency-hub',
  path: '/agency-hub',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/agency-hub.lazy.tsx').then((d) => d.Route),
)
const SecuredCampaignIndexLazyRoute =
  SecuredCampaignIndexLazyRouteImport.update({
    id: '/campaign/',
    path: '/campaign/',
    getParentRoute: () => SecuredRoute,
  } as any).lazy(() =>
    import('./routes/_secured/campaign/index.lazy.tsx').then((d) => d.Route),
  )
const SecuredAgencyHubIndexLazyRoute =
  SecuredAgencyHubIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAgencyHubRoute,
  } as any).lazy(() =>
    import('./routes/_secured/agency-hub/index.lazy.tsx').then((d) => d.Route),
  )
const LegalPrivacyPolicyIndexLazyRoute =
  LegalPrivacyPolicyIndexLazyRouteImport.update({
    id: '/privacy-policy/',
    path: '/privacy-policy/',
    getParentRoute: () => LegalRoute,
  } as any).lazy(() =>
    import('./routes/_legal/privacy-policy/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredTestigosIndexRoute = SecuredTestigosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecuredTestigosRoute,
} as any).lazy(() =>
  import('./routes/_secured/testigos/index.lazy.tsx').then((d) => d.Route),
)
const SecuredReportingIndexRoute = SecuredReportingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecuredReportingRoute,
} as any).lazy(() =>
  import('./routes/_secured/reporting/index.lazy.tsx').then((d) => d.Route),
)
const SecuredNotificationsIndexRoute =
  SecuredNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => SecuredRoute,
  } as any).lazy(() =>
    import('./routes/_secured/notifications/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredExternalDataIndexRoute =
  SecuredExternalDataIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredExternalDataRoute,
  } as any).lazy(() =>
    import('./routes/_secured/external-data/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileIndexRoute =
  SecuredCompanyProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCampaignsIndexRoute = SecuredCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/campaigns/index.lazy.tsx').then((d) => d.Route),
)
const SecuredAiHubIndexRoute = SecuredAiHubIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecuredAiHubRoute,
} as any).lazy(() =>
  import('./routes/_secured/ai-hub/index.lazy.tsx').then((d) => d.Route),
)
const AuthWorkspacesIndexRoute = AuthWorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/workspaces/index.lazy.tsx').then((d) => d.Route),
)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/login/index.lazy.tsx').then((d) => d.Route),
)
const AuthLoginAuth0IndexRoute = AuthLoginAuth0IndexRouteImport.update({
  id: '/login-auth0/',
  path: '/login-auth0/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/login-auth0/index.lazy.tsx').then((d) => d.Route),
)
const AuthExpiredLinkIndexRoute = AuthExpiredLinkIndexRouteImport.update({
  id: '/expired-link/',
  path: '/expired-link/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/expired-link/index.lazy.tsx').then((d) => d.Route),
)
const SecuredReportingDashboardsLazyRoute =
  SecuredReportingDashboardsLazyRouteImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => SecuredReportingRoute,
  } as any).lazy(() =>
    import('./routes/_secured/reporting/dashboards.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredExternalDataIntegrationsRoute =
  SecuredExternalDataIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => SecuredExternalDataRoute,
  } as any).lazy(() =>
    import('./routes/_secured/external-data/integrations.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredExternalDataImportHubRoute =
  SecuredExternalDataImportHubRouteImport.update({
    id: '/import-hub',
    path: '/import-hub',
    getParentRoute: () => SecuredExternalDataRoute,
  } as any).lazy(() =>
    import('./routes/_secured/external-data/import-hub.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileValuesManagerRoute =
  SecuredCompanyProfileValuesManagerRouteImport.update({
    id: '/values-manager',
    path: '/values-manager',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/values-manager.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileUsersManagementRoute =
  SecuredCompanyProfileUsersManagementRouteImport.update({
    id: '/users-management',
    path: '/users-management',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any)
const SecuredCompanyProfileUserActivitiesRoute =
  SecuredCompanyProfileUserActivitiesRouteImport.update({
    id: '/user-activities',
    path: '/user-activities',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/user-activities.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileNamingConventionRoute =
  SecuredCompanyProfileNamingConventionRouteImport.update({
    id: '/naming-convention',
    path: '/naming-convention',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/naming-convention.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileMetricsManagerRoute =
  SecuredCompanyProfileMetricsManagerRouteImport.update({
    id: '/metrics-manager',
    path: '/metrics-manager',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/metrics-manager.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileIntegrationsRoute =
  SecuredCompanyProfileIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/integrations.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileImportHubRoute =
  SecuredCompanyProfileImportHubRouteImport.update({
    id: '/import-hub',
    path: '/import-hub',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any)
const SecuredCompanyProfileFlowsRoute =
  SecuredCompanyProfileFlowsRouteImport.update({
    id: '/flows',
    path: '/flows',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/flows.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCampaignCampaignIdRoute =
  SecuredCampaignCampaignIdRouteImport.update({
    id: '/campaign/$campaignId',
    path: '/campaign/$campaignId',
    getParentRoute: () => SecuredRoute,
  } as any).lazy(() =>
    import('./routes/_secured/campaign/$campaignId.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredAgencyHubUsersManagementRoute =
  SecuredAgencyHubUsersManagementRouteImport.update({
    id: '/users-management',
    path: '/users-management',
    getParentRoute: () => SecuredAgencyHubRoute,
  } as any)
const SecuredReportingDashboardsIndexLazyRoute =
  SecuredReportingDashboardsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredReportingDashboardsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_secured/reporting/dashboards/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredExternalDataImportHubIndexLazyRoute =
  SecuredExternalDataImportHubIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredExternalDataImportHubRoute,
  } as any).lazy(() =>
    import('./routes/_secured/external-data/import-hub/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileValuesManagerIndexLazyRoute =
  SecuredCompanyProfileValuesManagerIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCompanyProfileValuesManagerRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/values-manager/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileMetricsManagerIndexLazyRoute =
  SecuredCompanyProfileMetricsManagerIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCompanyProfileMetricsManagerRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/metrics-manager/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileFlowsIndexLazyRoute =
  SecuredCompanyProfileFlowsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCompanyProfileFlowsRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/flows/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileCompanyInfoIndexLazyRoute =
  SecuredCompanyProfileCompanyInfoIndexLazyRouteImport.update({
    id: '/company-info/',
    path: '/company-info/',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/company-info/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileClientsIndexLazyRoute =
  SecuredCompanyProfileClientsIndexLazyRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/clients/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredAgencyHubAgencyInfoIndexLazyRoute =
  SecuredAgencyHubAgencyInfoIndexLazyRouteImport.update({
    id: '/agency-info/',
    path: '/agency-info/',
    getParentRoute: () => SecuredAgencyHubRoute,
  } as any).lazy(() =>
    import('./routes/_secured/agency-hub/agency-info/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredReportingDataExplorationIndexRoute =
  SecuredReportingDataExplorationIndexRouteImport.update({
    id: '/data-exploration/',
    path: '/data-exploration/',
    getParentRoute: () => SecuredReportingRoute,
  } as any).lazy(() =>
    import('./routes/_secured/reporting/data-exploration/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredExternalDataIntegrationsIndexRoute =
  SecuredExternalDataIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredExternalDataIntegrationsRoute,
  } as any).lazy(() =>
    import('./routes/_secured/external-data/integrations/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileUsersManagementIndexRoute =
  SecuredCompanyProfileUsersManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCompanyProfileUsersManagementRoute,
  } as any)
const SecuredCompanyProfileUserActivitiesIndexRoute =
  SecuredCompanyProfileUserActivitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCompanyProfileUserActivitiesRoute,
  } as any)
const SecuredCompanyProfileCurrenciesIndexRoute =
  SecuredCompanyProfileCurrenciesIndexRouteImport.update({
    id: '/currencies/',
    path: '/currencies/',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/currencies/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileBrandsIndexRoute =
  SecuredCompanyProfileBrandsIndexRouteImport.update({
    id: '/brands/',
    path: '/brands/',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/brands/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileAdvertisersIndexRoute =
  SecuredCompanyProfileAdvertisersIndexRouteImport.update({
    id: '/advertisers/',
    path: '/advertisers/',
    getParentRoute: () => SecuredCompanyProfileRoute,
  } as any).lazy(() =>
    import('./routes/_secured/company-profile/advertisers/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredAiHubChatIdIndexRoute = SecuredAiHubChatIdIndexRouteImport.update({
  id: '/$chatId/',
  path: '/$chatId/',
  getParentRoute: () => SecuredAiHubRoute,
} as any).lazy(() =>
  import('./routes/_secured/ai-hub/$chatId/index.lazy.tsx').then(
    (d) => d.Route,
  ),
)
const SecuredAgencyHubUsersManagementIndexRoute =
  SecuredAgencyHubUsersManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAgencyHubUsersManagementRoute,
  } as any)
const SecuredAgencyHubClientsIndexRoute =
  SecuredAgencyHubClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => SecuredAgencyHubRoute,
  } as any).lazy(() =>
    import('./routes/_secured/agency-hub/clients/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileNamingConventionIdLazyRoute =
  SecuredCompanyProfileNamingConventionIdLazyRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => SecuredCompanyProfileNamingConventionRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/naming-convention/$id.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdSettingsLazyRoute =
  SecuredCampaignCampaignIdSettingsLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SecuredCampaignCampaignIdRoute,
  } as any).lazy(() =>
    import('./routes/_secured/campaign/$campaignId/settings.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredExternalDataImportHubWhitelistedEmailsRoute =
  SecuredExternalDataImportHubWhitelistedEmailsRouteImport.update({
    id: '/whitelisted-emails',
    path: '/whitelisted-emails',
    getParentRoute: () => SecuredExternalDataImportHubRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/whitelisted-emails.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubCustomMetricsRoute =
  SecuredExternalDataImportHubCustomMetricsRouteImport.update({
    id: '/custom-metrics',
    path: '/custom-metrics',
    getParentRoute: () => SecuredExternalDataImportHubRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/custom-metrics.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileNamingConventionNewRoute =
  SecuredCompanyProfileNamingConventionNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SecuredCompanyProfileNamingConventionRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/naming-convention/new.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdTraffickingRoute =
  SecuredCampaignCampaignIdTraffickingRouteImport.update({
    id: '/trafficking',
    path: '/trafficking',
    getParentRoute: () => SecuredCampaignCampaignIdRoute,
  } as any)
const SecuredCampaignCampaignIdStrategyRoute =
  SecuredCampaignCampaignIdStrategyRouteImport.update({
    id: '/strategy',
    path: '/strategy',
    getParentRoute: () => SecuredCampaignCampaignIdRoute,
  } as any).lazy(() =>
    import('./routes/_secured/campaign/$campaignId/strategy.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredCompanyProfileUsersManagementRoleIndexLazyRoute =
  SecuredCompanyProfileUsersManagementRoleIndexLazyRouteImport.update({
    id: '/role/',
    path: '/role/',
    getParentRoute: () => SecuredCompanyProfileUsersManagementRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/users-management/role/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute =
  SecuredCompanyProfileUserActivitiesUserViewIndexLazyRouteImport.update({
    id: '/user-view/',
    path: '/user-view/',
    getParentRoute: () => SecuredCompanyProfileUserActivitiesRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/user-activities/user-view/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute =
  SecuredCompanyProfileUserActivitiesActionViewIndexLazyRouteImport.update({
    id: '/action-view/',
    path: '/action-view/',
    getParentRoute: () => SecuredCompanyProfileUserActivitiesRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/user-activities/action-view/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileFlowsFlowIdIndexLazyRoute =
  SecuredCompanyProfileFlowsFlowIdIndexLazyRouteImport.update({
    id: '/$flowId/',
    path: '/$flowId/',
    getParentRoute: () => SecuredCompanyProfileFlowsRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/flows/$flowId/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredAgencyHubUsersManagementRoleIndexLazyRoute =
  SecuredAgencyHubUsersManagementRoleIndexLazyRouteImport.update({
    id: '/role/',
    path: '/role/',
    getParentRoute: () => SecuredAgencyHubUsersManagementRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/agency-hub/users-management/role/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredReportingDashboardsBoardIdIndexRoute =
  SecuredReportingDashboardsBoardIdIndexRouteImport.update({
    id: '/$boardId/',
    path: '/$boardId/',
    getParentRoute: () => SecuredReportingDashboardsLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/reporting/dashboards/$boardId/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubPerformanceIndexRoute =
  SecuredExternalDataImportHubPerformanceIndexRouteImport.update({
    id: '/performance/',
    path: '/performance/',
    getParentRoute: () => SecuredExternalDataImportHubRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/performance/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileUsersManagementUserIndexRoute =
  SecuredCompanyProfileUsersManagementUserIndexRouteImport.update({
    id: '/user/',
    path: '/user/',
    getParentRoute: () => SecuredCompanyProfileUsersManagementRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/users-management/user/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileFlowsNewFlowIndexRoute =
  SecuredCompanyProfileFlowsNewFlowIndexRouteImport.update({
    id: '/new-flow/',
    path: '/new-flow/',
    getParentRoute: () => SecuredCompanyProfileFlowsRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/flows/new-flow/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdTraffickingIndexRoute =
  SecuredCampaignCampaignIdTraffickingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCampaignCampaignIdTraffickingRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/trafficking/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdSettingsIndexRoute =
  SecuredCampaignCampaignIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCampaignCampaignIdSettingsLazyRoute,
  } as any)
const SecuredCampaignCampaignIdPlanningIndexRoute =
  SecuredCampaignCampaignIdPlanningIndexRouteImport.update({
    id: '/planning/',
    path: '/planning/',
    getParentRoute: () => SecuredCampaignCampaignIdRoute,
  } as any)
const SecuredAgencyHubUsersManagementUserIndexRoute =
  SecuredAgencyHubUsersManagementUserIndexRouteImport.update({
    id: '/user/',
    path: '/user/',
    getParentRoute: () => SecuredAgencyHubUsersManagementRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/agency-hub/users-management/user/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute =
  SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRouteImport.update({
    id: '/$integration/suggestion-emails',
    path: '/$integration/suggestion-emails',
    getParentRoute: () => SecuredExternalDataIntegrationsRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/integrations/$integration/suggestion-emails.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataIntegrationsIntegrationConnectionsRoute =
  SecuredExternalDataIntegrationsIntegrationConnectionsRouteImport.update({
    id: '/$integration/connections',
    path: '/$integration/connections',
    getParentRoute: () => SecuredExternalDataIntegrationsRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/integrations/$integration/connections.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataIntegrationsIntegrationTabNameRoute =
  SecuredExternalDataIntegrationsIntegrationTabNameRouteImport.update({
    id: '/$integration/$tabName',
    path: '/$integration/$tabName',
    getParentRoute: () => SecuredExternalDataIntegrationsRoute,
  } as any)
const SecuredCampaignCampaignIdPlanningInsertionOrdersRoute =
  SecuredCampaignCampaignIdPlanningInsertionOrdersRouteImport.update({
    id: '/planning/insertion-orders',
    path: '/planning/insertion-orders',
    getParentRoute: () => SecuredCampaignCampaignIdRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/planning/insertion-orders.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdPlanningBuyingPlanRoute =
  SecuredCampaignCampaignIdPlanningBuyingPlanRouteImport.update({
    id: '/planning/buying-plan',
    path: '/planning/buying-plan',
    getParentRoute: () => SecuredCampaignCampaignIdRoute,
  } as any)
const SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute =
  SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      SecuredExternalDataIntegrationsIntegrationTabNameRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/integrations/$integration/$tabName/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute =
  SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRouteImport.update({
    id: '/$flowId/update/',
    path: '/$flowId/update/',
    getParentRoute: () => SecuredCompanyProfileFlowsRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/company-profile/flows/$flowId/update/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute =
  SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRouteImport.update({
    id: '/campaign-info/',
    path: '/campaign-info/',
    getParentRoute: () => SecuredCampaignCampaignIdStrategyRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/strategy/campaign-info/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute =
  SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRouteImport.update(
    {
      id: '/campaign-description/',
      path: '/campaign-description/',
      getParentRoute: () => SecuredCampaignCampaignIdStrategyRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/strategy/campaign-description/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute =
  SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCampaignCampaignIdPlanningInsertionOrdersRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/planning/insertion-orders/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute =
  SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredCampaignCampaignIdPlanningBuyingPlanRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/planning/buying-plan/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute =
  SecuredCampaignCampaignIdTraffickingAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => SecuredCampaignCampaignIdTraffickingRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/trafficking/analytics/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute =
  SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRouteImport.update({
    id: '/mediamix/$mediaMixName',
    path: '/mediamix/$mediaMixName',
    getParentRoute: () => SecuredCampaignCampaignIdStrategyRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/strategy/mediamix/$mediaMixName.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdSettingsOmniPlatformLazyRoute =
  SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteImport.update({
    id: '/omni/$platform',
    path: '/omni/$platform',
    getParentRoute: () => SecuredCampaignCampaignIdSettingsLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/settings/omni/$platform.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute =
  SecuredExternalDataIntegrationsIntegrationConnectionsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      SecuredExternalDataIntegrationsIntegrationConnectionsRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/integrations/$integration/connections/add.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubPerformanceImportsNewRoute =
  SecuredExternalDataImportHubPerformanceImportsNewRouteImport.update({
    id: '/performance/imports/new',
    path: '/performance/imports/new',
    getParentRoute: () => SecuredExternalDataImportHubRoute,
  } as any)
const SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute =
  SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteImport.update({
    id: '/performance/imports/$dataFileId',
    path: '/performance/imports/$dataFileId',
    getParentRoute: () => SecuredExternalDataImportHubRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/performance/imports/$dataFileId.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute =
  SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRouteImport.update(
    {
      id: '/$id/',
      path: '/$id/',
      getParentRoute: () =>
        SecuredCampaignCampaignIdPlanningInsertionOrdersRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/planning/insertion-orders/$id/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute =
  SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRouteImport.update({
    id: '/$type/',
    path: '/$type/',
    getParentRoute: () =>
      SecuredExternalDataIntegrationsIntegrationTabNameRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/external-data/integrations/$integration/$tabName/$type/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute =
  SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRouteImport.update(
    {
      id: '/upload',
      path: '/upload',
      getParentRoute: () =>
        SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/upload.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute =
  SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRouteImport.update(
    {
      id: '/$connection/update',
      path: '/$connection/update',
      getParentRoute: () =>
        SecuredExternalDataIntegrationsIntegrationConnectionsRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/external-data/integrations/$integration/connections/$connection/update.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute =
  SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRouteImport.update(
    {
      id: '/validation',
      path: '/validation',
      getParentRoute: () =>
        SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/validation.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute =
  SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRouteImport.update(
    {
      id: '/headers-mapping',
      path: '/headers-mapping',
      getParentRoute: () =>
        SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/headers-mapping.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute =
  SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRouteImport.update(
    {
      id: '/header-selection',
      path: '/header-selection',
      getParentRoute: () =>
        SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/header-selection.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute =
  SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRouteImport.update(
    {
      id: '/data-assignment',
      path: '/data-assignment',
      getParentRoute: () =>
        SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute =
  SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteImport.update({
    id: '/$tileId',
    path: '/$tileId',
    getParentRoute: () =>
      SecuredCampaignCampaignIdSettingsOmniPlatformLazyRoute,
  } as any)
const SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute =
  SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRouteImport.update({
    id: '/ghost/$tileId/settings/',
    path: '/ghost/$tileId/settings/',
    getParentRoute: () => SecuredCampaignCampaignIdSettingsLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/settings/ghost/$tileId/settings/index.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute =
  SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/settings.lazy.tsx'
    ).then((d) => d.Route),
  )
const SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute =
  SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () =>
      SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute,
  } as any).lazy(() =>
    import(
      './routes/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/import.lazy.tsx'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agency-hub': typeof SecuredAgencyHubRouteWithChildren
  '/ai-hub': typeof SecuredAiHubRouteWithChildren
  '/company-profile': typeof SecuredCompanyProfileRouteWithChildren
  '/external-data': typeof SecuredExternalDataRouteWithChildren
  '/insights': typeof SecuredInsightsRoute
  '/reporting': typeof SecuredReportingRouteWithChildren
  '/testigos': typeof SecuredTestigosRouteWithChildren
  '/agency-hub/users-management': typeof SecuredAgencyHubUsersManagementRouteWithChildren
  '/campaign/$campaignId': typeof SecuredCampaignCampaignIdRouteWithChildren
  '/company-profile/flows': typeof SecuredCompanyProfileFlowsRouteWithChildren
  '/company-profile/import-hub': typeof SecuredCompanyProfileImportHubRoute
  '/company-profile/integrations': typeof SecuredCompanyProfileIntegrationsRoute
  '/company-profile/metrics-manager': typeof SecuredCompanyProfileMetricsManagerRouteWithChildren
  '/company-profile/naming-convention': typeof SecuredCompanyProfileNamingConventionRouteWithChildren
  '/company-profile/user-activities': typeof SecuredCompanyProfileUserActivitiesRouteWithChildren
  '/company-profile/users-management': typeof SecuredCompanyProfileUsersManagementRouteWithChildren
  '/company-profile/values-manager': typeof SecuredCompanyProfileValuesManagerRouteWithChildren
  '/external-data/import-hub': typeof SecuredExternalDataImportHubRouteWithChildren
  '/external-data/integrations': typeof SecuredExternalDataIntegrationsRouteWithChildren
  '/reporting/dashboards': typeof SecuredReportingDashboardsLazyRouteWithChildren
  '/expired-link/': typeof AuthExpiredLinkIndexRoute
  '/login-auth0/': typeof AuthLoginAuth0IndexRoute
  '/login/': typeof AuthLoginIndexRoute
  '/workspaces/': typeof AuthWorkspacesIndexRoute
  '/ai-hub/': typeof SecuredAiHubIndexRoute
  '/campaigns/': typeof SecuredCampaignsIndexRoute
  '/company-profile/': typeof SecuredCompanyProfileIndexRoute
  '/external-data/': typeof SecuredExternalDataIndexRoute
  '/notifications/': typeof SecuredNotificationsIndexRoute
  '/reporting/': typeof SecuredReportingIndexRoute
  '/testigos/': typeof SecuredTestigosIndexRoute
  '/privacy-policy/': typeof LegalPrivacyPolicyIndexLazyRoute
  '/agency-hub/': typeof SecuredAgencyHubIndexLazyRoute
  '/campaign/': typeof SecuredCampaignIndexLazyRoute
  '/campaign/$campaignId/strategy': typeof SecuredCampaignCampaignIdStrategyRouteWithChildren
  '/campaign/$campaignId/trafficking': typeof SecuredCampaignCampaignIdTraffickingRouteWithChildren
  '/company-profile/naming-convention/new': typeof SecuredCompanyProfileNamingConventionNewRoute
  '/external-data/import-hub/custom-metrics': typeof SecuredExternalDataImportHubCustomMetricsRoute
  '/external-data/import-hub/whitelisted-emails': typeof SecuredExternalDataImportHubWhitelistedEmailsRoute
  '/campaign/$campaignId/settings': typeof SecuredCampaignCampaignIdSettingsLazyRouteWithChildren
  '/company-profile/naming-convention/$id': typeof SecuredCompanyProfileNamingConventionIdLazyRoute
  '/agency-hub/clients/': typeof SecuredAgencyHubClientsIndexRoute
  '/agency-hub/users-management/': typeof SecuredAgencyHubUsersManagementIndexRoute
  '/ai-hub/$chatId/': typeof SecuredAiHubChatIdIndexRoute
  '/company-profile/advertisers/': typeof SecuredCompanyProfileAdvertisersIndexRoute
  '/company-profile/brands/': typeof SecuredCompanyProfileBrandsIndexRoute
  '/company-profile/currencies/': typeof SecuredCompanyProfileCurrenciesIndexRoute
  '/company-profile/user-activities/': typeof SecuredCompanyProfileUserActivitiesIndexRoute
  '/company-profile/users-management/': typeof SecuredCompanyProfileUsersManagementIndexRoute
  '/external-data/integrations/': typeof SecuredExternalDataIntegrationsIndexRoute
  '/reporting/data-exploration/': typeof SecuredReportingDataExplorationIndexRoute
  '/agency-hub/agency-info/': typeof SecuredAgencyHubAgencyInfoIndexLazyRoute
  '/company-profile/clients/': typeof SecuredCompanyProfileClientsIndexLazyRoute
  '/company-profile/company-info/': typeof SecuredCompanyProfileCompanyInfoIndexLazyRoute
  '/company-profile/flows/': typeof SecuredCompanyProfileFlowsIndexLazyRoute
  '/company-profile/metrics-manager/': typeof SecuredCompanyProfileMetricsManagerIndexLazyRoute
  '/company-profile/values-manager/': typeof SecuredCompanyProfileValuesManagerIndexLazyRoute
  '/external-data/import-hub/': typeof SecuredExternalDataImportHubIndexLazyRoute
  '/reporting/dashboards/': typeof SecuredReportingDashboardsIndexLazyRoute
  '/campaign/$campaignId/planning/buying-plan': typeof SecuredCampaignCampaignIdPlanningBuyingPlanRouteWithChildren
  '/campaign/$campaignId/planning/insertion-orders': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersRouteWithChildren
  '/external-data/integrations/$integration/$tabName': typeof SecuredExternalDataIntegrationsIntegrationTabNameRouteWithChildren
  '/external-data/integrations/$integration/connections': typeof SecuredExternalDataIntegrationsIntegrationConnectionsRouteWithChildren
  '/external-data/integrations/$integration/suggestion-emails': typeof SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute
  '/agency-hub/users-management/user/': typeof SecuredAgencyHubUsersManagementUserIndexRoute
  '/campaign/$campaignId/planning/': typeof SecuredCampaignCampaignIdPlanningIndexRoute
  '/campaign/$campaignId/settings/': typeof SecuredCampaignCampaignIdSettingsIndexRoute
  '/campaign/$campaignId/trafficking/': typeof SecuredCampaignCampaignIdTraffickingIndexRoute
  '/company-profile/flows/new-flow/': typeof SecuredCompanyProfileFlowsNewFlowIndexRoute
  '/company-profile/users-management/user/': typeof SecuredCompanyProfileUsersManagementUserIndexRoute
  '/external-data/import-hub/performance/': typeof SecuredExternalDataImportHubPerformanceIndexRoute
  '/reporting/dashboards/$boardId/': typeof SecuredReportingDashboardsBoardIdIndexRoute
  '/agency-hub/users-management/role/': typeof SecuredAgencyHubUsersManagementRoleIndexLazyRoute
  '/company-profile/flows/$flowId/': typeof SecuredCompanyProfileFlowsFlowIdIndexLazyRoute
  '/company-profile/user-activities/action-view/': typeof SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute
  '/company-profile/user-activities/user-view/': typeof SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute
  '/company-profile/users-management/role/': typeof SecuredCompanyProfileUsersManagementRoleIndexLazyRoute
  '/external-data/import-hub/performance/imports/$dataFileId': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteWithChildren
  '/external-data/import-hub/performance/imports/new': typeof SecuredExternalDataImportHubPerformanceImportsNewRoute
  '/external-data/integrations/$integration/connections/add': typeof SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute
  '/campaign/$campaignId/settings/omni/$platform': typeof SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteWithChildren
  '/campaign/$campaignId/strategy/mediamix/$mediaMixName': typeof SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute
  '/campaign/$campaignId/trafficking/analytics/': typeof SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute
  '/campaign/$campaignId/planning/buying-plan/': typeof SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute
  '/campaign/$campaignId/planning/insertion-orders/': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute
  '/campaign/$campaignId/strategy/campaign-description/': typeof SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute
  '/campaign/$campaignId/strategy/campaign-info/': typeof SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute
  '/company-profile/flows/$flowId/update/': typeof SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute
  '/external-data/integrations/$integration/$tabName/': typeof SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute
  '/campaign/$campaignId/settings/omni/$platform/$tileId': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteWithChildren
  '/external-data/import-hub/performance/imports/$dataFileId/data-assignment': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute
  '/external-data/import-hub/performance/imports/$dataFileId/header-selection': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute
  '/external-data/import-hub/performance/imports/$dataFileId/headers-mapping': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute
  '/external-data/import-hub/performance/imports/$dataFileId/validation': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute
  '/external-data/integrations/$integration/connections/$connection/update': typeof SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute
  '/external-data/import-hub/performance/imports/$dataFileId/upload': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute
  '/external-data/integrations/$integration/$tabName/$type/': typeof SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute
  '/campaign/$campaignId/planning/insertion-orders/$id/': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute
  '/campaign/$campaignId/settings/omni/$platform/$tileId/import': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute
  '/campaign/$campaignId/settings/omni/$platform/$tileId/settings': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute
  '/campaign/$campaignId/settings/ghost/$tileId/settings/': typeof SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/insights': typeof SecuredInsightsRoute
  '/campaign/$campaignId': typeof SecuredCampaignCampaignIdRouteWithChildren
  '/company-profile/import-hub': typeof SecuredCompanyProfileImportHubRoute
  '/company-profile/integrations': typeof SecuredCompanyProfileIntegrationsRoute
  '/company-profile/naming-convention': typeof SecuredCompanyProfileNamingConventionRouteWithChildren
  '/expired-link': typeof AuthExpiredLinkIndexRoute
  '/login-auth0': typeof AuthLoginAuth0IndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/workspaces': typeof AuthWorkspacesIndexRoute
  '/ai-hub': typeof SecuredAiHubIndexRoute
  '/campaigns': typeof SecuredCampaignsIndexRoute
  '/company-profile': typeof SecuredCompanyProfileIndexRoute
  '/external-data': typeof SecuredExternalDataIndexRoute
  '/notifications': typeof SecuredNotificationsIndexRoute
  '/reporting': typeof SecuredReportingIndexRoute
  '/testigos': typeof SecuredTestigosIndexRoute
  '/privacy-policy': typeof LegalPrivacyPolicyIndexLazyRoute
  '/agency-hub': typeof SecuredAgencyHubIndexLazyRoute
  '/campaign': typeof SecuredCampaignIndexLazyRoute
  '/campaign/$campaignId/strategy': typeof SecuredCampaignCampaignIdStrategyRouteWithChildren
  '/company-profile/naming-convention/new': typeof SecuredCompanyProfileNamingConventionNewRoute
  '/external-data/import-hub/custom-metrics': typeof SecuredExternalDataImportHubCustomMetricsRoute
  '/external-data/import-hub/whitelisted-emails': typeof SecuredExternalDataImportHubWhitelistedEmailsRoute
  '/company-profile/naming-convention/$id': typeof SecuredCompanyProfileNamingConventionIdLazyRoute
  '/agency-hub/clients': typeof SecuredAgencyHubClientsIndexRoute
  '/agency-hub/users-management': typeof SecuredAgencyHubUsersManagementIndexRoute
  '/ai-hub/$chatId': typeof SecuredAiHubChatIdIndexRoute
  '/company-profile/advertisers': typeof SecuredCompanyProfileAdvertisersIndexRoute
  '/company-profile/brands': typeof SecuredCompanyProfileBrandsIndexRoute
  '/company-profile/currencies': typeof SecuredCompanyProfileCurrenciesIndexRoute
  '/company-profile/user-activities': typeof SecuredCompanyProfileUserActivitiesIndexRoute
  '/company-profile/users-management': typeof SecuredCompanyProfileUsersManagementIndexRoute
  '/external-data/integrations': typeof SecuredExternalDataIntegrationsIndexRoute
  '/reporting/data-exploration': typeof SecuredReportingDataExplorationIndexRoute
  '/agency-hub/agency-info': typeof SecuredAgencyHubAgencyInfoIndexLazyRoute
  '/company-profile/clients': typeof SecuredCompanyProfileClientsIndexLazyRoute
  '/company-profile/company-info': typeof SecuredCompanyProfileCompanyInfoIndexLazyRoute
  '/company-profile/flows': typeof SecuredCompanyProfileFlowsIndexLazyRoute
  '/company-profile/metrics-manager': typeof SecuredCompanyProfileMetricsManagerIndexLazyRoute
  '/company-profile/values-manager': typeof SecuredCompanyProfileValuesManagerIndexLazyRoute
  '/external-data/import-hub': typeof SecuredExternalDataImportHubIndexLazyRoute
  '/reporting/dashboards': typeof SecuredReportingDashboardsIndexLazyRoute
  '/external-data/integrations/$integration/connections': typeof SecuredExternalDataIntegrationsIntegrationConnectionsRouteWithChildren
  '/external-data/integrations/$integration/suggestion-emails': typeof SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute
  '/agency-hub/users-management/user': typeof SecuredAgencyHubUsersManagementUserIndexRoute
  '/campaign/$campaignId/planning': typeof SecuredCampaignCampaignIdPlanningIndexRoute
  '/campaign/$campaignId/settings': typeof SecuredCampaignCampaignIdSettingsIndexRoute
  '/campaign/$campaignId/trafficking': typeof SecuredCampaignCampaignIdTraffickingIndexRoute
  '/company-profile/flows/new-flow': typeof SecuredCompanyProfileFlowsNewFlowIndexRoute
  '/company-profile/users-management/user': typeof SecuredCompanyProfileUsersManagementUserIndexRoute
  '/external-data/import-hub/performance': typeof SecuredExternalDataImportHubPerformanceIndexRoute
  '/reporting/dashboards/$boardId': typeof SecuredReportingDashboardsBoardIdIndexRoute
  '/agency-hub/users-management/role': typeof SecuredAgencyHubUsersManagementRoleIndexLazyRoute
  '/company-profile/flows/$flowId': typeof SecuredCompanyProfileFlowsFlowIdIndexLazyRoute
  '/company-profile/user-activities/action-view': typeof SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute
  '/company-profile/user-activities/user-view': typeof SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute
  '/company-profile/users-management/role': typeof SecuredCompanyProfileUsersManagementRoleIndexLazyRoute
  '/external-data/import-hub/performance/imports/$dataFileId': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteWithChildren
  '/external-data/import-hub/performance/imports/new': typeof SecuredExternalDataImportHubPerformanceImportsNewRoute
  '/external-data/integrations/$integration/connections/add': typeof SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute
  '/campaign/$campaignId/settings/omni/$platform': typeof SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteWithChildren
  '/campaign/$campaignId/strategy/mediamix/$mediaMixName': typeof SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute
  '/campaign/$campaignId/trafficking/analytics': typeof SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute
  '/campaign/$campaignId/planning/buying-plan': typeof SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute
  '/campaign/$campaignId/planning/insertion-orders': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute
  '/campaign/$campaignId/strategy/campaign-description': typeof SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute
  '/campaign/$campaignId/strategy/campaign-info': typeof SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute
  '/company-profile/flows/$flowId/update': typeof SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute
  '/external-data/integrations/$integration/$tabName': typeof SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute
  '/campaign/$campaignId/settings/omni/$platform/$tileId': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteWithChildren
  '/external-data/import-hub/performance/imports/$dataFileId/data-assignment': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute
  '/external-data/import-hub/performance/imports/$dataFileId/header-selection': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute
  '/external-data/import-hub/performance/imports/$dataFileId/headers-mapping': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute
  '/external-data/import-hub/performance/imports/$dataFileId/validation': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute
  '/external-data/integrations/$integration/connections/$connection/update': typeof SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute
  '/external-data/import-hub/performance/imports/$dataFileId/upload': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute
  '/external-data/integrations/$integration/$tabName/$type': typeof SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute
  '/campaign/$campaignId/planning/insertion-orders/$id': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute
  '/campaign/$campaignId/settings/omni/$platform/$tileId/import': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute
  '/campaign/$campaignId/settings/omni/$platform/$tileId/settings': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute
  '/campaign/$campaignId/settings/ghost/$tileId/settings': typeof SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_legal': typeof LegalRouteWithChildren
  '/_secured': typeof SecuredRouteWithChildren
  '/_secured/agency-hub': typeof SecuredAgencyHubRouteWithChildren
  '/_secured/ai-hub': typeof SecuredAiHubRouteWithChildren
  '/_secured/company-profile': typeof SecuredCompanyProfileRouteWithChildren
  '/_secured/external-data': typeof SecuredExternalDataRouteWithChildren
  '/_secured/insights': typeof SecuredInsightsRoute
  '/_secured/reporting': typeof SecuredReportingRouteWithChildren
  '/_secured/testigos': typeof SecuredTestigosRouteWithChildren
  '/_secured/agency-hub/users-management': typeof SecuredAgencyHubUsersManagementRouteWithChildren
  '/_secured/campaign/$campaignId': typeof SecuredCampaignCampaignIdRouteWithChildren
  '/_secured/company-profile/flows': typeof SecuredCompanyProfileFlowsRouteWithChildren
  '/_secured/company-profile/import-hub': typeof SecuredCompanyProfileImportHubRoute
  '/_secured/company-profile/integrations': typeof SecuredCompanyProfileIntegrationsRoute
  '/_secured/company-profile/metrics-manager': typeof SecuredCompanyProfileMetricsManagerRouteWithChildren
  '/_secured/company-profile/naming-convention': typeof SecuredCompanyProfileNamingConventionRouteWithChildren
  '/_secured/company-profile/user-activities': typeof SecuredCompanyProfileUserActivitiesRouteWithChildren
  '/_secured/company-profile/users-management': typeof SecuredCompanyProfileUsersManagementRouteWithChildren
  '/_secured/company-profile/values-manager': typeof SecuredCompanyProfileValuesManagerRouteWithChildren
  '/_secured/external-data/import-hub': typeof SecuredExternalDataImportHubRouteWithChildren
  '/_secured/external-data/integrations': typeof SecuredExternalDataIntegrationsRouteWithChildren
  '/_secured/reporting/dashboards': typeof SecuredReportingDashboardsLazyRouteWithChildren
  '/_auth/expired-link/': typeof AuthExpiredLinkIndexRoute
  '/_auth/login-auth0/': typeof AuthLoginAuth0IndexRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_auth/workspaces/': typeof AuthWorkspacesIndexRoute
  '/_secured/ai-hub/': typeof SecuredAiHubIndexRoute
  '/_secured/campaigns/': typeof SecuredCampaignsIndexRoute
  '/_secured/company-profile/': typeof SecuredCompanyProfileIndexRoute
  '/_secured/external-data/': typeof SecuredExternalDataIndexRoute
  '/_secured/notifications/': typeof SecuredNotificationsIndexRoute
  '/_secured/reporting/': typeof SecuredReportingIndexRoute
  '/_secured/testigos/': typeof SecuredTestigosIndexRoute
  '/_legal/privacy-policy/': typeof LegalPrivacyPolicyIndexLazyRoute
  '/_secured/agency-hub/': typeof SecuredAgencyHubIndexLazyRoute
  '/_secured/campaign/': typeof SecuredCampaignIndexLazyRoute
  '/_secured/campaign/$campaignId/strategy': typeof SecuredCampaignCampaignIdStrategyRouteWithChildren
  '/_secured/campaign/$campaignId/trafficking': typeof SecuredCampaignCampaignIdTraffickingRouteWithChildren
  '/_secured/company-profile/naming-convention/new': typeof SecuredCompanyProfileNamingConventionNewRoute
  '/_secured/external-data/import-hub/custom-metrics': typeof SecuredExternalDataImportHubCustomMetricsRoute
  '/_secured/external-data/import-hub/whitelisted-emails': typeof SecuredExternalDataImportHubWhitelistedEmailsRoute
  '/_secured/campaign/$campaignId/settings': typeof SecuredCampaignCampaignIdSettingsLazyRouteWithChildren
  '/_secured/company-profile/naming-convention/$id': typeof SecuredCompanyProfileNamingConventionIdLazyRoute
  '/_secured/agency-hub/clients/': typeof SecuredAgencyHubClientsIndexRoute
  '/_secured/agency-hub/users-management/': typeof SecuredAgencyHubUsersManagementIndexRoute
  '/_secured/ai-hub/$chatId/': typeof SecuredAiHubChatIdIndexRoute
  '/_secured/company-profile/advertisers/': typeof SecuredCompanyProfileAdvertisersIndexRoute
  '/_secured/company-profile/brands/': typeof SecuredCompanyProfileBrandsIndexRoute
  '/_secured/company-profile/currencies/': typeof SecuredCompanyProfileCurrenciesIndexRoute
  '/_secured/company-profile/user-activities/': typeof SecuredCompanyProfileUserActivitiesIndexRoute
  '/_secured/company-profile/users-management/': typeof SecuredCompanyProfileUsersManagementIndexRoute
  '/_secured/external-data/integrations/': typeof SecuredExternalDataIntegrationsIndexRoute
  '/_secured/reporting/data-exploration/': typeof SecuredReportingDataExplorationIndexRoute
  '/_secured/agency-hub/agency-info/': typeof SecuredAgencyHubAgencyInfoIndexLazyRoute
  '/_secured/company-profile/clients/': typeof SecuredCompanyProfileClientsIndexLazyRoute
  '/_secured/company-profile/company-info/': typeof SecuredCompanyProfileCompanyInfoIndexLazyRoute
  '/_secured/company-profile/flows/': typeof SecuredCompanyProfileFlowsIndexLazyRoute
  '/_secured/company-profile/metrics-manager/': typeof SecuredCompanyProfileMetricsManagerIndexLazyRoute
  '/_secured/company-profile/values-manager/': typeof SecuredCompanyProfileValuesManagerIndexLazyRoute
  '/_secured/external-data/import-hub/': typeof SecuredExternalDataImportHubIndexLazyRoute
  '/_secured/reporting/dashboards/': typeof SecuredReportingDashboardsIndexLazyRoute
  '/_secured/campaign/$campaignId/planning/buying-plan': typeof SecuredCampaignCampaignIdPlanningBuyingPlanRouteWithChildren
  '/_secured/campaign/$campaignId/planning/insertion-orders': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersRouteWithChildren
  '/_secured/external-data/integrations/$integration/$tabName': typeof SecuredExternalDataIntegrationsIntegrationTabNameRouteWithChildren
  '/_secured/external-data/integrations/$integration/connections': typeof SecuredExternalDataIntegrationsIntegrationConnectionsRouteWithChildren
  '/_secured/external-data/integrations/$integration/suggestion-emails': typeof SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute
  '/_secured/agency-hub/users-management/user/': typeof SecuredAgencyHubUsersManagementUserIndexRoute
  '/_secured/campaign/$campaignId/planning/': typeof SecuredCampaignCampaignIdPlanningIndexRoute
  '/_secured/campaign/$campaignId/settings/': typeof SecuredCampaignCampaignIdSettingsIndexRoute
  '/_secured/campaign/$campaignId/trafficking/': typeof SecuredCampaignCampaignIdTraffickingIndexRoute
  '/_secured/company-profile/flows/new-flow/': typeof SecuredCompanyProfileFlowsNewFlowIndexRoute
  '/_secured/company-profile/users-management/user/': typeof SecuredCompanyProfileUsersManagementUserIndexRoute
  '/_secured/external-data/import-hub/performance/': typeof SecuredExternalDataImportHubPerformanceIndexRoute
  '/_secured/reporting/dashboards/$boardId/': typeof SecuredReportingDashboardsBoardIdIndexRoute
  '/_secured/agency-hub/users-management/role/': typeof SecuredAgencyHubUsersManagementRoleIndexLazyRoute
  '/_secured/company-profile/flows/$flowId/': typeof SecuredCompanyProfileFlowsFlowIdIndexLazyRoute
  '/_secured/company-profile/user-activities/action-view/': typeof SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute
  '/_secured/company-profile/user-activities/user-view/': typeof SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute
  '/_secured/company-profile/users-management/role/': typeof SecuredCompanyProfileUsersManagementRoleIndexLazyRoute
  '/_secured/external-data/import-hub/performance/imports/$dataFileId': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteWithChildren
  '/_secured/external-data/import-hub/performance/imports/new': typeof SecuredExternalDataImportHubPerformanceImportsNewRoute
  '/_secured/external-data/integrations/$integration/connections/add': typeof SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute
  '/_secured/campaign/$campaignId/settings/omni/$platform': typeof SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteWithChildren
  '/_secured/campaign/$campaignId/strategy/mediamix/$mediaMixName': typeof SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute
  '/_secured/campaign/$campaignId/trafficking/analytics/': typeof SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute
  '/_secured/campaign/$campaignId/planning/buying-plan/': typeof SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute
  '/_secured/campaign/$campaignId/planning/insertion-orders/': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute
  '/_secured/campaign/$campaignId/strategy/campaign-description/': typeof SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute
  '/_secured/campaign/$campaignId/strategy/campaign-info/': typeof SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute
  '/_secured/company-profile/flows/$flowId/update/': typeof SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute
  '/_secured/external-data/integrations/$integration/$tabName/': typeof SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute
  '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteWithChildren
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/header-selection': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/headers-mapping': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/validation': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute
  '/_secured/external-data/integrations/$integration/connections/$connection/update': typeof SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/upload': typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute
  '/_secured/external-data/integrations/$integration/$tabName/$type/': typeof SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute
  '/_secured/campaign/$campaignId/planning/insertion-orders/$id/': typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute
  '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/import': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute
  '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/settings': typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute
  '/_secured/campaign/$campaignId/settings/ghost/$tileId/settings/': typeof SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agency-hub'
    | '/ai-hub'
    | '/company-profile'
    | '/external-data'
    | '/insights'
    | '/reporting'
    | '/testigos'
    | '/agency-hub/users-management'
    | '/campaign/$campaignId'
    | '/company-profile/flows'
    | '/company-profile/import-hub'
    | '/company-profile/integrations'
    | '/company-profile/metrics-manager'
    | '/company-profile/naming-convention'
    | '/company-profile/user-activities'
    | '/company-profile/users-management'
    | '/company-profile/values-manager'
    | '/external-data/import-hub'
    | '/external-data/integrations'
    | '/reporting/dashboards'
    | '/expired-link/'
    | '/login-auth0/'
    | '/login/'
    | '/workspaces/'
    | '/ai-hub/'
    | '/campaigns/'
    | '/company-profile/'
    | '/external-data/'
    | '/notifications/'
    | '/reporting/'
    | '/testigos/'
    | '/privacy-policy/'
    | '/agency-hub/'
    | '/campaign/'
    | '/campaign/$campaignId/strategy'
    | '/campaign/$campaignId/trafficking'
    | '/company-profile/naming-convention/new'
    | '/external-data/import-hub/custom-metrics'
    | '/external-data/import-hub/whitelisted-emails'
    | '/campaign/$campaignId/settings'
    | '/company-profile/naming-convention/$id'
    | '/agency-hub/clients/'
    | '/agency-hub/users-management/'
    | '/ai-hub/$chatId/'
    | '/company-profile/advertisers/'
    | '/company-profile/brands/'
    | '/company-profile/currencies/'
    | '/company-profile/user-activities/'
    | '/company-profile/users-management/'
    | '/external-data/integrations/'
    | '/reporting/data-exploration/'
    | '/agency-hub/agency-info/'
    | '/company-profile/clients/'
    | '/company-profile/company-info/'
    | '/company-profile/flows/'
    | '/company-profile/metrics-manager/'
    | '/company-profile/values-manager/'
    | '/external-data/import-hub/'
    | '/reporting/dashboards/'
    | '/campaign/$campaignId/planning/buying-plan'
    | '/campaign/$campaignId/planning/insertion-orders'
    | '/external-data/integrations/$integration/$tabName'
    | '/external-data/integrations/$integration/connections'
    | '/external-data/integrations/$integration/suggestion-emails'
    | '/agency-hub/users-management/user/'
    | '/campaign/$campaignId/planning/'
    | '/campaign/$campaignId/settings/'
    | '/campaign/$campaignId/trafficking/'
    | '/company-profile/flows/new-flow/'
    | '/company-profile/users-management/user/'
    | '/external-data/import-hub/performance/'
    | '/reporting/dashboards/$boardId/'
    | '/agency-hub/users-management/role/'
    | '/company-profile/flows/$flowId/'
    | '/company-profile/user-activities/action-view/'
    | '/company-profile/user-activities/user-view/'
    | '/company-profile/users-management/role/'
    | '/external-data/import-hub/performance/imports/$dataFileId'
    | '/external-data/import-hub/performance/imports/new'
    | '/external-data/integrations/$integration/connections/add'
    | '/campaign/$campaignId/settings/omni/$platform'
    | '/campaign/$campaignId/strategy/mediamix/$mediaMixName'
    | '/campaign/$campaignId/trafficking/analytics/'
    | '/campaign/$campaignId/planning/buying-plan/'
    | '/campaign/$campaignId/planning/insertion-orders/'
    | '/campaign/$campaignId/strategy/campaign-description/'
    | '/campaign/$campaignId/strategy/campaign-info/'
    | '/company-profile/flows/$flowId/update/'
    | '/external-data/integrations/$integration/$tabName/'
    | '/campaign/$campaignId/settings/omni/$platform/$tileId'
    | '/external-data/import-hub/performance/imports/$dataFileId/data-assignment'
    | '/external-data/import-hub/performance/imports/$dataFileId/header-selection'
    | '/external-data/import-hub/performance/imports/$dataFileId/headers-mapping'
    | '/external-data/import-hub/performance/imports/$dataFileId/validation'
    | '/external-data/integrations/$integration/connections/$connection/update'
    | '/external-data/import-hub/performance/imports/$dataFileId/upload'
    | '/external-data/integrations/$integration/$tabName/$type/'
    | '/campaign/$campaignId/planning/insertion-orders/$id/'
    | '/campaign/$campaignId/settings/omni/$platform/$tileId/import'
    | '/campaign/$campaignId/settings/omni/$platform/$tileId/settings'
    | '/campaign/$campaignId/settings/ghost/$tileId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/insights'
    | '/campaign/$campaignId'
    | '/company-profile/import-hub'
    | '/company-profile/integrations'
    | '/company-profile/naming-convention'
    | '/expired-link'
    | '/login-auth0'
    | '/login'
    | '/workspaces'
    | '/ai-hub'
    | '/campaigns'
    | '/company-profile'
    | '/external-data'
    | '/notifications'
    | '/reporting'
    | '/testigos'
    | '/privacy-policy'
    | '/agency-hub'
    | '/campaign'
    | '/campaign/$campaignId/strategy'
    | '/company-profile/naming-convention/new'
    | '/external-data/import-hub/custom-metrics'
    | '/external-data/import-hub/whitelisted-emails'
    | '/company-profile/naming-convention/$id'
    | '/agency-hub/clients'
    | '/agency-hub/users-management'
    | '/ai-hub/$chatId'
    | '/company-profile/advertisers'
    | '/company-profile/brands'
    | '/company-profile/currencies'
    | '/company-profile/user-activities'
    | '/company-profile/users-management'
    | '/external-data/integrations'
    | '/reporting/data-exploration'
    | '/agency-hub/agency-info'
    | '/company-profile/clients'
    | '/company-profile/company-info'
    | '/company-profile/flows'
    | '/company-profile/metrics-manager'
    | '/company-profile/values-manager'
    | '/external-data/import-hub'
    | '/reporting/dashboards'
    | '/external-data/integrations/$integration/connections'
    | '/external-data/integrations/$integration/suggestion-emails'
    | '/agency-hub/users-management/user'
    | '/campaign/$campaignId/planning'
    | '/campaign/$campaignId/settings'
    | '/campaign/$campaignId/trafficking'
    | '/company-profile/flows/new-flow'
    | '/company-profile/users-management/user'
    | '/external-data/import-hub/performance'
    | '/reporting/dashboards/$boardId'
    | '/agency-hub/users-management/role'
    | '/company-profile/flows/$flowId'
    | '/company-profile/user-activities/action-view'
    | '/company-profile/user-activities/user-view'
    | '/company-profile/users-management/role'
    | '/external-data/import-hub/performance/imports/$dataFileId'
    | '/external-data/import-hub/performance/imports/new'
    | '/external-data/integrations/$integration/connections/add'
    | '/campaign/$campaignId/settings/omni/$platform'
    | '/campaign/$campaignId/strategy/mediamix/$mediaMixName'
    | '/campaign/$campaignId/trafficking/analytics'
    | '/campaign/$campaignId/planning/buying-plan'
    | '/campaign/$campaignId/planning/insertion-orders'
    | '/campaign/$campaignId/strategy/campaign-description'
    | '/campaign/$campaignId/strategy/campaign-info'
    | '/company-profile/flows/$flowId/update'
    | '/external-data/integrations/$integration/$tabName'
    | '/campaign/$campaignId/settings/omni/$platform/$tileId'
    | '/external-data/import-hub/performance/imports/$dataFileId/data-assignment'
    | '/external-data/import-hub/performance/imports/$dataFileId/header-selection'
    | '/external-data/import-hub/performance/imports/$dataFileId/headers-mapping'
    | '/external-data/import-hub/performance/imports/$dataFileId/validation'
    | '/external-data/integrations/$integration/connections/$connection/update'
    | '/external-data/import-hub/performance/imports/$dataFileId/upload'
    | '/external-data/integrations/$integration/$tabName/$type'
    | '/campaign/$campaignId/planning/insertion-orders/$id'
    | '/campaign/$campaignId/settings/omni/$platform/$tileId/import'
    | '/campaign/$campaignId/settings/omni/$platform/$tileId/settings'
    | '/campaign/$campaignId/settings/ghost/$tileId/settings'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_legal'
    | '/_secured'
    | '/_secured/agency-hub'
    | '/_secured/ai-hub'
    | '/_secured/company-profile'
    | '/_secured/external-data'
    | '/_secured/insights'
    | '/_secured/reporting'
    | '/_secured/testigos'
    | '/_secured/agency-hub/users-management'
    | '/_secured/campaign/$campaignId'
    | '/_secured/company-profile/flows'
    | '/_secured/company-profile/import-hub'
    | '/_secured/company-profile/integrations'
    | '/_secured/company-profile/metrics-manager'
    | '/_secured/company-profile/naming-convention'
    | '/_secured/company-profile/user-activities'
    | '/_secured/company-profile/users-management'
    | '/_secured/company-profile/values-manager'
    | '/_secured/external-data/import-hub'
    | '/_secured/external-data/integrations'
    | '/_secured/reporting/dashboards'
    | '/_auth/expired-link/'
    | '/_auth/login-auth0/'
    | '/_auth/login/'
    | '/_auth/workspaces/'
    | '/_secured/ai-hub/'
    | '/_secured/campaigns/'
    | '/_secured/company-profile/'
    | '/_secured/external-data/'
    | '/_secured/notifications/'
    | '/_secured/reporting/'
    | '/_secured/testigos/'
    | '/_legal/privacy-policy/'
    | '/_secured/agency-hub/'
    | '/_secured/campaign/'
    | '/_secured/campaign/$campaignId/strategy'
    | '/_secured/campaign/$campaignId/trafficking'
    | '/_secured/company-profile/naming-convention/new'
    | '/_secured/external-data/import-hub/custom-metrics'
    | '/_secured/external-data/import-hub/whitelisted-emails'
    | '/_secured/campaign/$campaignId/settings'
    | '/_secured/company-profile/naming-convention/$id'
    | '/_secured/agency-hub/clients/'
    | '/_secured/agency-hub/users-management/'
    | '/_secured/ai-hub/$chatId/'
    | '/_secured/company-profile/advertisers/'
    | '/_secured/company-profile/brands/'
    | '/_secured/company-profile/currencies/'
    | '/_secured/company-profile/user-activities/'
    | '/_secured/company-profile/users-management/'
    | '/_secured/external-data/integrations/'
    | '/_secured/reporting/data-exploration/'
    | '/_secured/agency-hub/agency-info/'
    | '/_secured/company-profile/clients/'
    | '/_secured/company-profile/company-info/'
    | '/_secured/company-profile/flows/'
    | '/_secured/company-profile/metrics-manager/'
    | '/_secured/company-profile/values-manager/'
    | '/_secured/external-data/import-hub/'
    | '/_secured/reporting/dashboards/'
    | '/_secured/campaign/$campaignId/planning/buying-plan'
    | '/_secured/campaign/$campaignId/planning/insertion-orders'
    | '/_secured/external-data/integrations/$integration/$tabName'
    | '/_secured/external-data/integrations/$integration/connections'
    | '/_secured/external-data/integrations/$integration/suggestion-emails'
    | '/_secured/agency-hub/users-management/user/'
    | '/_secured/campaign/$campaignId/planning/'
    | '/_secured/campaign/$campaignId/settings/'
    | '/_secured/campaign/$campaignId/trafficking/'
    | '/_secured/company-profile/flows/new-flow/'
    | '/_secured/company-profile/users-management/user/'
    | '/_secured/external-data/import-hub/performance/'
    | '/_secured/reporting/dashboards/$boardId/'
    | '/_secured/agency-hub/users-management/role/'
    | '/_secured/company-profile/flows/$flowId/'
    | '/_secured/company-profile/user-activities/action-view/'
    | '/_secured/company-profile/user-activities/user-view/'
    | '/_secured/company-profile/users-management/role/'
    | '/_secured/external-data/import-hub/performance/imports/$dataFileId'
    | '/_secured/external-data/import-hub/performance/imports/new'
    | '/_secured/external-data/integrations/$integration/connections/add'
    | '/_secured/campaign/$campaignId/settings/omni/$platform'
    | '/_secured/campaign/$campaignId/strategy/mediamix/$mediaMixName'
    | '/_secured/campaign/$campaignId/trafficking/analytics/'
    | '/_secured/campaign/$campaignId/planning/buying-plan/'
    | '/_secured/campaign/$campaignId/planning/insertion-orders/'
    | '/_secured/campaign/$campaignId/strategy/campaign-description/'
    | '/_secured/campaign/$campaignId/strategy/campaign-info/'
    | '/_secured/company-profile/flows/$flowId/update/'
    | '/_secured/external-data/integrations/$integration/$tabName/'
    | '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId'
    | '/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment'
    | '/_secured/external-data/import-hub/performance/imports/$dataFileId/header-selection'
    | '/_secured/external-data/import-hub/performance/imports/$dataFileId/headers-mapping'
    | '/_secured/external-data/import-hub/performance/imports/$dataFileId/validation'
    | '/_secured/external-data/integrations/$integration/connections/$connection/update'
    | '/_secured/external-data/import-hub/performance/imports/$dataFileId/upload'
    | '/_secured/external-data/integrations/$integration/$tabName/$type/'
    | '/_secured/campaign/$campaignId/planning/insertion-orders/$id/'
    | '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/import'
    | '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/settings'
    | '/_secured/campaign/$campaignId/settings/ghost/$tileId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LegalRoute: typeof LegalRouteWithChildren
  SecuredRoute: typeof SecuredRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_secured': {
      id: '/_secured'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SecuredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_legal': {
      id: '/_legal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secured/testigos': {
      id: '/_secured/testigos'
      path: '/testigos'
      fullPath: '/testigos'
      preLoaderRoute: typeof SecuredTestigosRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/reporting': {
      id: '/_secured/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof SecuredReportingRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/insights': {
      id: '/_secured/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof SecuredInsightsRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/external-data': {
      id: '/_secured/external-data'
      path: '/external-data'
      fullPath: '/external-data'
      preLoaderRoute: typeof SecuredExternalDataRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/company-profile': {
      id: '/_secured/company-profile'
      path: '/company-profile'
      fullPath: '/company-profile'
      preLoaderRoute: typeof SecuredCompanyProfileRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/ai-hub': {
      id: '/_secured/ai-hub'
      path: '/ai-hub'
      fullPath: '/ai-hub'
      preLoaderRoute: typeof SecuredAiHubRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/agency-hub': {
      id: '/_secured/agency-hub'
      path: '/agency-hub'
      fullPath: '/agency-hub'
      preLoaderRoute: typeof SecuredAgencyHubRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/campaign/': {
      id: '/_secured/campaign/'
      path: '/campaign'
      fullPath: '/campaign/'
      preLoaderRoute: typeof SecuredCampaignIndexLazyRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/agency-hub/': {
      id: '/_secured/agency-hub/'
      path: '/'
      fullPath: '/agency-hub/'
      preLoaderRoute: typeof SecuredAgencyHubIndexLazyRouteImport
      parentRoute: typeof SecuredAgencyHubRoute
    }
    '/_legal/privacy-policy/': {
      id: '/_legal/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy/'
      preLoaderRoute: typeof LegalPrivacyPolicyIndexLazyRouteImport
      parentRoute: typeof LegalRoute
    }
    '/_secured/testigos/': {
      id: '/_secured/testigos/'
      path: '/'
      fullPath: '/testigos/'
      preLoaderRoute: typeof SecuredTestigosIndexRouteImport
      parentRoute: typeof SecuredTestigosRoute
    }
    '/_secured/reporting/': {
      id: '/_secured/reporting/'
      path: '/'
      fullPath: '/reporting/'
      preLoaderRoute: typeof SecuredReportingIndexRouteImport
      parentRoute: typeof SecuredReportingRoute
    }
    '/_secured/notifications/': {
      id: '/_secured/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof SecuredNotificationsIndexRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/external-data/': {
      id: '/_secured/external-data/'
      path: '/'
      fullPath: '/external-data/'
      preLoaderRoute: typeof SecuredExternalDataIndexRouteImport
      parentRoute: typeof SecuredExternalDataRoute
    }
    '/_secured/company-profile/': {
      id: '/_secured/company-profile/'
      path: '/'
      fullPath: '/company-profile/'
      preLoaderRoute: typeof SecuredCompanyProfileIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/campaigns/': {
      id: '/_secured/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof SecuredCampaignsIndexRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/ai-hub/': {
      id: '/_secured/ai-hub/'
      path: '/'
      fullPath: '/ai-hub/'
      preLoaderRoute: typeof SecuredAiHubIndexRouteImport
      parentRoute: typeof SecuredAiHubRoute
    }
    '/_auth/workspaces/': {
      id: '/_auth/workspaces/'
      path: '/workspaces'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof AuthWorkspacesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-auth0/': {
      id: '/_auth/login-auth0/'
      path: '/login-auth0'
      fullPath: '/login-auth0/'
      preLoaderRoute: typeof AuthLoginAuth0IndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/expired-link/': {
      id: '/_auth/expired-link/'
      path: '/expired-link'
      fullPath: '/expired-link/'
      preLoaderRoute: typeof AuthExpiredLinkIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_secured/reporting/dashboards': {
      id: '/_secured/reporting/dashboards'
      path: '/dashboards'
      fullPath: '/reporting/dashboards'
      preLoaderRoute: typeof SecuredReportingDashboardsLazyRouteImport
      parentRoute: typeof SecuredReportingRoute
    }
    '/_secured/external-data/integrations': {
      id: '/_secured/external-data/integrations'
      path: '/integrations'
      fullPath: '/external-data/integrations'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsRouteImport
      parentRoute: typeof SecuredExternalDataRoute
    }
    '/_secured/external-data/import-hub': {
      id: '/_secured/external-data/import-hub'
      path: '/import-hub'
      fullPath: '/external-data/import-hub'
      preLoaderRoute: typeof SecuredExternalDataImportHubRouteImport
      parentRoute: typeof SecuredExternalDataRoute
    }
    '/_secured/company-profile/values-manager': {
      id: '/_secured/company-profile/values-manager'
      path: '/values-manager'
      fullPath: '/company-profile/values-manager'
      preLoaderRoute: typeof SecuredCompanyProfileValuesManagerRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/users-management': {
      id: '/_secured/company-profile/users-management'
      path: '/users-management'
      fullPath: '/company-profile/users-management'
      preLoaderRoute: typeof SecuredCompanyProfileUsersManagementRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/user-activities': {
      id: '/_secured/company-profile/user-activities'
      path: '/user-activities'
      fullPath: '/company-profile/user-activities'
      preLoaderRoute: typeof SecuredCompanyProfileUserActivitiesRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/naming-convention': {
      id: '/_secured/company-profile/naming-convention'
      path: '/naming-convention'
      fullPath: '/company-profile/naming-convention'
      preLoaderRoute: typeof SecuredCompanyProfileNamingConventionRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/metrics-manager': {
      id: '/_secured/company-profile/metrics-manager'
      path: '/metrics-manager'
      fullPath: '/company-profile/metrics-manager'
      preLoaderRoute: typeof SecuredCompanyProfileMetricsManagerRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/integrations': {
      id: '/_secured/company-profile/integrations'
      path: '/integrations'
      fullPath: '/company-profile/integrations'
      preLoaderRoute: typeof SecuredCompanyProfileIntegrationsRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/import-hub': {
      id: '/_secured/company-profile/import-hub'
      path: '/import-hub'
      fullPath: '/company-profile/import-hub'
      preLoaderRoute: typeof SecuredCompanyProfileImportHubRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/flows': {
      id: '/_secured/company-profile/flows'
      path: '/flows'
      fullPath: '/company-profile/flows'
      preLoaderRoute: typeof SecuredCompanyProfileFlowsRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/campaign/$campaignId': {
      id: '/_secured/campaign/$campaignId'
      path: '/campaign/$campaignId'
      fullPath: '/campaign/$campaignId'
      preLoaderRoute: typeof SecuredCampaignCampaignIdRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/agency-hub/users-management': {
      id: '/_secured/agency-hub/users-management'
      path: '/users-management'
      fullPath: '/agency-hub/users-management'
      preLoaderRoute: typeof SecuredAgencyHubUsersManagementRouteImport
      parentRoute: typeof SecuredAgencyHubRoute
    }
    '/_secured/reporting/dashboards/': {
      id: '/_secured/reporting/dashboards/'
      path: '/'
      fullPath: '/reporting/dashboards/'
      preLoaderRoute: typeof SecuredReportingDashboardsIndexLazyRouteImport
      parentRoute: typeof SecuredReportingDashboardsLazyRoute
    }
    '/_secured/external-data/import-hub/': {
      id: '/_secured/external-data/import-hub/'
      path: '/'
      fullPath: '/external-data/import-hub/'
      preLoaderRoute: typeof SecuredExternalDataImportHubIndexLazyRouteImport
      parentRoute: typeof SecuredExternalDataImportHubRoute
    }
    '/_secured/company-profile/values-manager/': {
      id: '/_secured/company-profile/values-manager/'
      path: '/'
      fullPath: '/company-profile/values-manager/'
      preLoaderRoute: typeof SecuredCompanyProfileValuesManagerIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileValuesManagerRoute
    }
    '/_secured/company-profile/metrics-manager/': {
      id: '/_secured/company-profile/metrics-manager/'
      path: '/'
      fullPath: '/company-profile/metrics-manager/'
      preLoaderRoute: typeof SecuredCompanyProfileMetricsManagerIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileMetricsManagerRoute
    }
    '/_secured/company-profile/flows/': {
      id: '/_secured/company-profile/flows/'
      path: '/'
      fullPath: '/company-profile/flows/'
      preLoaderRoute: typeof SecuredCompanyProfileFlowsIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileFlowsRoute
    }
    '/_secured/company-profile/company-info/': {
      id: '/_secured/company-profile/company-info/'
      path: '/company-info'
      fullPath: '/company-profile/company-info/'
      preLoaderRoute: typeof SecuredCompanyProfileCompanyInfoIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/clients/': {
      id: '/_secured/company-profile/clients/'
      path: '/clients'
      fullPath: '/company-profile/clients/'
      preLoaderRoute: typeof SecuredCompanyProfileClientsIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/agency-hub/agency-info/': {
      id: '/_secured/agency-hub/agency-info/'
      path: '/agency-info'
      fullPath: '/agency-hub/agency-info/'
      preLoaderRoute: typeof SecuredAgencyHubAgencyInfoIndexLazyRouteImport
      parentRoute: typeof SecuredAgencyHubRoute
    }
    '/_secured/reporting/data-exploration/': {
      id: '/_secured/reporting/data-exploration/'
      path: '/data-exploration'
      fullPath: '/reporting/data-exploration/'
      preLoaderRoute: typeof SecuredReportingDataExplorationIndexRouteImport
      parentRoute: typeof SecuredReportingRoute
    }
    '/_secured/external-data/integrations/': {
      id: '/_secured/external-data/integrations/'
      path: '/'
      fullPath: '/external-data/integrations/'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIndexRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsRoute
    }
    '/_secured/company-profile/users-management/': {
      id: '/_secured/company-profile/users-management/'
      path: '/'
      fullPath: '/company-profile/users-management/'
      preLoaderRoute: typeof SecuredCompanyProfileUsersManagementIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileUsersManagementRoute
    }
    '/_secured/company-profile/user-activities/': {
      id: '/_secured/company-profile/user-activities/'
      path: '/'
      fullPath: '/company-profile/user-activities/'
      preLoaderRoute: typeof SecuredCompanyProfileUserActivitiesIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileUserActivitiesRoute
    }
    '/_secured/company-profile/currencies/': {
      id: '/_secured/company-profile/currencies/'
      path: '/currencies'
      fullPath: '/company-profile/currencies/'
      preLoaderRoute: typeof SecuredCompanyProfileCurrenciesIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/brands/': {
      id: '/_secured/company-profile/brands/'
      path: '/brands'
      fullPath: '/company-profile/brands/'
      preLoaderRoute: typeof SecuredCompanyProfileBrandsIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/company-profile/advertisers/': {
      id: '/_secured/company-profile/advertisers/'
      path: '/advertisers'
      fullPath: '/company-profile/advertisers/'
      preLoaderRoute: typeof SecuredCompanyProfileAdvertisersIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileRoute
    }
    '/_secured/ai-hub/$chatId/': {
      id: '/_secured/ai-hub/$chatId/'
      path: '/$chatId'
      fullPath: '/ai-hub/$chatId/'
      preLoaderRoute: typeof SecuredAiHubChatIdIndexRouteImport
      parentRoute: typeof SecuredAiHubRoute
    }
    '/_secured/agency-hub/users-management/': {
      id: '/_secured/agency-hub/users-management/'
      path: '/'
      fullPath: '/agency-hub/users-management/'
      preLoaderRoute: typeof SecuredAgencyHubUsersManagementIndexRouteImport
      parentRoute: typeof SecuredAgencyHubUsersManagementRoute
    }
    '/_secured/agency-hub/clients/': {
      id: '/_secured/agency-hub/clients/'
      path: '/clients'
      fullPath: '/agency-hub/clients/'
      preLoaderRoute: typeof SecuredAgencyHubClientsIndexRouteImport
      parentRoute: typeof SecuredAgencyHubRoute
    }
    '/_secured/company-profile/naming-convention/$id': {
      id: '/_secured/company-profile/naming-convention/$id'
      path: '/$id'
      fullPath: '/company-profile/naming-convention/$id'
      preLoaderRoute: typeof SecuredCompanyProfileNamingConventionIdLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileNamingConventionRoute
    }
    '/_secured/campaign/$campaignId/settings': {
      id: '/_secured/campaign/$campaignId/settings'
      path: '/settings'
      fullPath: '/campaign/$campaignId/settings'
      preLoaderRoute: typeof SecuredCampaignCampaignIdSettingsLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdRoute
    }
    '/_secured/external-data/import-hub/whitelisted-emails': {
      id: '/_secured/external-data/import-hub/whitelisted-emails'
      path: '/whitelisted-emails'
      fullPath: '/external-data/import-hub/whitelisted-emails'
      preLoaderRoute: typeof SecuredExternalDataImportHubWhitelistedEmailsRouteImport
      parentRoute: typeof SecuredExternalDataImportHubRoute
    }
    '/_secured/external-data/import-hub/custom-metrics': {
      id: '/_secured/external-data/import-hub/custom-metrics'
      path: '/custom-metrics'
      fullPath: '/external-data/import-hub/custom-metrics'
      preLoaderRoute: typeof SecuredExternalDataImportHubCustomMetricsRouteImport
      parentRoute: typeof SecuredExternalDataImportHubRoute
    }
    '/_secured/company-profile/naming-convention/new': {
      id: '/_secured/company-profile/naming-convention/new'
      path: '/new'
      fullPath: '/company-profile/naming-convention/new'
      preLoaderRoute: typeof SecuredCompanyProfileNamingConventionNewRouteImport
      parentRoute: typeof SecuredCompanyProfileNamingConventionRoute
    }
    '/_secured/campaign/$campaignId/trafficking': {
      id: '/_secured/campaign/$campaignId/trafficking'
      path: '/trafficking'
      fullPath: '/campaign/$campaignId/trafficking'
      preLoaderRoute: typeof SecuredCampaignCampaignIdTraffickingRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdRoute
    }
    '/_secured/campaign/$campaignId/strategy': {
      id: '/_secured/campaign/$campaignId/strategy'
      path: '/strategy'
      fullPath: '/campaign/$campaignId/strategy'
      preLoaderRoute: typeof SecuredCampaignCampaignIdStrategyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdRoute
    }
    '/_secured/company-profile/users-management/role/': {
      id: '/_secured/company-profile/users-management/role/'
      path: '/role'
      fullPath: '/company-profile/users-management/role/'
      preLoaderRoute: typeof SecuredCompanyProfileUsersManagementRoleIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileUsersManagementRoute
    }
    '/_secured/company-profile/user-activities/user-view/': {
      id: '/_secured/company-profile/user-activities/user-view/'
      path: '/user-view'
      fullPath: '/company-profile/user-activities/user-view/'
      preLoaderRoute: typeof SecuredCompanyProfileUserActivitiesUserViewIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileUserActivitiesRoute
    }
    '/_secured/company-profile/user-activities/action-view/': {
      id: '/_secured/company-profile/user-activities/action-view/'
      path: '/action-view'
      fullPath: '/company-profile/user-activities/action-view/'
      preLoaderRoute: typeof SecuredCompanyProfileUserActivitiesActionViewIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileUserActivitiesRoute
    }
    '/_secured/company-profile/flows/$flowId/': {
      id: '/_secured/company-profile/flows/$flowId/'
      path: '/$flowId'
      fullPath: '/company-profile/flows/$flowId/'
      preLoaderRoute: typeof SecuredCompanyProfileFlowsFlowIdIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileFlowsRoute
    }
    '/_secured/agency-hub/users-management/role/': {
      id: '/_secured/agency-hub/users-management/role/'
      path: '/role'
      fullPath: '/agency-hub/users-management/role/'
      preLoaderRoute: typeof SecuredAgencyHubUsersManagementRoleIndexLazyRouteImport
      parentRoute: typeof SecuredAgencyHubUsersManagementRoute
    }
    '/_secured/reporting/dashboards/$boardId/': {
      id: '/_secured/reporting/dashboards/$boardId/'
      path: '/$boardId'
      fullPath: '/reporting/dashboards/$boardId/'
      preLoaderRoute: typeof SecuredReportingDashboardsBoardIdIndexRouteImport
      parentRoute: typeof SecuredReportingDashboardsLazyRoute
    }
    '/_secured/external-data/import-hub/performance/': {
      id: '/_secured/external-data/import-hub/performance/'
      path: '/performance'
      fullPath: '/external-data/import-hub/performance/'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceIndexRouteImport
      parentRoute: typeof SecuredExternalDataImportHubRoute
    }
    '/_secured/company-profile/users-management/user/': {
      id: '/_secured/company-profile/users-management/user/'
      path: '/user'
      fullPath: '/company-profile/users-management/user/'
      preLoaderRoute: typeof SecuredCompanyProfileUsersManagementUserIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileUsersManagementRoute
    }
    '/_secured/company-profile/flows/new-flow/': {
      id: '/_secured/company-profile/flows/new-flow/'
      path: '/new-flow'
      fullPath: '/company-profile/flows/new-flow/'
      preLoaderRoute: typeof SecuredCompanyProfileFlowsNewFlowIndexRouteImport
      parentRoute: typeof SecuredCompanyProfileFlowsRoute
    }
    '/_secured/campaign/$campaignId/trafficking/': {
      id: '/_secured/campaign/$campaignId/trafficking/'
      path: '/'
      fullPath: '/campaign/$campaignId/trafficking/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdTraffickingIndexRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdTraffickingRoute
    }
    '/_secured/campaign/$campaignId/settings/': {
      id: '/_secured/campaign/$campaignId/settings/'
      path: '/'
      fullPath: '/campaign/$campaignId/settings/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdSettingsIndexRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdSettingsLazyRoute
    }
    '/_secured/campaign/$campaignId/planning/': {
      id: '/_secured/campaign/$campaignId/planning/'
      path: '/planning'
      fullPath: '/campaign/$campaignId/planning/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdPlanningIndexRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdRoute
    }
    '/_secured/agency-hub/users-management/user/': {
      id: '/_secured/agency-hub/users-management/user/'
      path: '/user'
      fullPath: '/agency-hub/users-management/user/'
      preLoaderRoute: typeof SecuredAgencyHubUsersManagementUserIndexRouteImport
      parentRoute: typeof SecuredAgencyHubUsersManagementRoute
    }
    '/_secured/external-data/integrations/$integration/suggestion-emails': {
      id: '/_secured/external-data/integrations/$integration/suggestion-emails'
      path: '/$integration/suggestion-emails'
      fullPath: '/external-data/integrations/$integration/suggestion-emails'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsRoute
    }
    '/_secured/external-data/integrations/$integration/connections': {
      id: '/_secured/external-data/integrations/$integration/connections'
      path: '/$integration/connections'
      fullPath: '/external-data/integrations/$integration/connections'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsRoute
    }
    '/_secured/external-data/integrations/$integration/$tabName': {
      id: '/_secured/external-data/integrations/$integration/$tabName'
      path: '/$integration/$tabName'
      fullPath: '/external-data/integrations/$integration/$tabName'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsRoute
    }
    '/_secured/campaign/$campaignId/planning/insertion-orders': {
      id: '/_secured/campaign/$campaignId/planning/insertion-orders'
      path: '/planning/insertion-orders'
      fullPath: '/campaign/$campaignId/planning/insertion-orders'
      preLoaderRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdRoute
    }
    '/_secured/campaign/$campaignId/planning/buying-plan': {
      id: '/_secured/campaign/$campaignId/planning/buying-plan'
      path: '/planning/buying-plan'
      fullPath: '/campaign/$campaignId/planning/buying-plan'
      preLoaderRoute: typeof SecuredCampaignCampaignIdPlanningBuyingPlanRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdRoute
    }
    '/_secured/external-data/integrations/$integration/$tabName/': {
      id: '/_secured/external-data/integrations/$integration/$tabName/'
      path: '/'
      fullPath: '/external-data/integrations/$integration/$tabName/'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameRoute
    }
    '/_secured/company-profile/flows/$flowId/update/': {
      id: '/_secured/company-profile/flows/$flowId/update/'
      path: '/$flowId/update'
      fullPath: '/company-profile/flows/$flowId/update/'
      preLoaderRoute: typeof SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRouteImport
      parentRoute: typeof SecuredCompanyProfileFlowsRoute
    }
    '/_secured/campaign/$campaignId/strategy/campaign-info/': {
      id: '/_secured/campaign/$campaignId/strategy/campaign-info/'
      path: '/campaign-info'
      fullPath: '/campaign/$campaignId/strategy/campaign-info/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdStrategyRoute
    }
    '/_secured/campaign/$campaignId/strategy/campaign-description/': {
      id: '/_secured/campaign/$campaignId/strategy/campaign-description/'
      path: '/campaign-description'
      fullPath: '/campaign/$campaignId/strategy/campaign-description/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdStrategyRoute
    }
    '/_secured/campaign/$campaignId/planning/insertion-orders/': {
      id: '/_secured/campaign/$campaignId/planning/insertion-orders/'
      path: '/'
      fullPath: '/campaign/$campaignId/planning/insertion-orders/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersRoute
    }
    '/_secured/campaign/$campaignId/planning/buying-plan/': {
      id: '/_secured/campaign/$campaignId/planning/buying-plan/'
      path: '/'
      fullPath: '/campaign/$campaignId/planning/buying-plan/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdPlanningBuyingPlanRoute
    }
    '/_secured/campaign/$campaignId/trafficking/analytics/': {
      id: '/_secured/campaign/$campaignId/trafficking/analytics/'
      path: '/analytics'
      fullPath: '/campaign/$campaignId/trafficking/analytics/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdTraffickingAnalyticsIndexRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdTraffickingRoute
    }
    '/_secured/campaign/$campaignId/strategy/mediamix/$mediaMixName': {
      id: '/_secured/campaign/$campaignId/strategy/mediamix/$mediaMixName'
      path: '/mediamix/$mediaMixName'
      fullPath: '/campaign/$campaignId/strategy/mediamix/$mediaMixName'
      preLoaderRoute: typeof SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdStrategyRoute
    }
    '/_secured/campaign/$campaignId/settings/omni/$platform': {
      id: '/_secured/campaign/$campaignId/settings/omni/$platform'
      path: '/omni/$platform'
      fullPath: '/campaign/$campaignId/settings/omni/$platform'
      preLoaderRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdSettingsLazyRoute
    }
    '/_secured/external-data/integrations/$integration/connections/add': {
      id: '/_secured/external-data/integrations/$integration/connections/add'
      path: '/add'
      fullPath: '/external-data/integrations/$integration/connections/add'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsAddRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsRoute
    }
    '/_secured/external-data/import-hub/performance/imports/new': {
      id: '/_secured/external-data/import-hub/performance/imports/new'
      path: '/performance/imports/new'
      fullPath: '/external-data/import-hub/performance/imports/new'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceImportsNewRouteImport
      parentRoute: typeof SecuredExternalDataImportHubRoute
    }
    '/_secured/external-data/import-hub/performance/imports/$dataFileId': {
      id: '/_secured/external-data/import-hub/performance/imports/$dataFileId'
      path: '/performance/imports/$dataFileId'
      fullPath: '/external-data/import-hub/performance/imports/$dataFileId'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteImport
      parentRoute: typeof SecuredExternalDataImportHubRoute
    }
    '/_secured/campaign/$campaignId/planning/insertion-orders/$id/': {
      id: '/_secured/campaign/$campaignId/planning/insertion-orders/$id/'
      path: '/$id'
      fullPath: '/campaign/$campaignId/planning/insertion-orders/$id/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersRoute
    }
    '/_secured/external-data/integrations/$integration/$tabName/$type/': {
      id: '/_secured/external-data/integrations/$integration/$tabName/$type/'
      path: '/$type'
      fullPath: '/external-data/integrations/$integration/$tabName/$type/'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameRoute
    }
    '/_secured/external-data/import-hub/performance/imports/$dataFileId/upload': {
      id: '/_secured/external-data/import-hub/performance/imports/$dataFileId/upload'
      path: '/upload'
      fullPath: '/external-data/import-hub/performance/imports/$dataFileId/upload'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRouteImport
      parentRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute
    }
    '/_secured/external-data/integrations/$integration/connections/$connection/update': {
      id: '/_secured/external-data/integrations/$integration/connections/$connection/update'
      path: '/$connection/update'
      fullPath: '/external-data/integrations/$integration/connections/$connection/update'
      preLoaderRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRouteImport
      parentRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsRoute
    }
    '/_secured/external-data/import-hub/performance/imports/$dataFileId/validation': {
      id: '/_secured/external-data/import-hub/performance/imports/$dataFileId/validation'
      path: '/validation'
      fullPath: '/external-data/import-hub/performance/imports/$dataFileId/validation'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRouteImport
      parentRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute
    }
    '/_secured/external-data/import-hub/performance/imports/$dataFileId/headers-mapping': {
      id: '/_secured/external-data/import-hub/performance/imports/$dataFileId/headers-mapping'
      path: '/headers-mapping'
      fullPath: '/external-data/import-hub/performance/imports/$dataFileId/headers-mapping'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRouteImport
      parentRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute
    }
    '/_secured/external-data/import-hub/performance/imports/$dataFileId/header-selection': {
      id: '/_secured/external-data/import-hub/performance/imports/$dataFileId/header-selection'
      path: '/header-selection'
      fullPath: '/external-data/import-hub/performance/imports/$dataFileId/header-selection'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRouteImport
      parentRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute
    }
    '/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment': {
      id: '/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment'
      path: '/data-assignment'
      fullPath: '/external-data/import-hub/performance/imports/$dataFileId/data-assignment'
      preLoaderRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRouteImport
      parentRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute
    }
    '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId': {
      id: '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId'
      path: '/$tileId'
      fullPath: '/campaign/$campaignId/settings/omni/$platform/$tileId'
      preLoaderRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformLazyRoute
    }
    '/_secured/campaign/$campaignId/settings/ghost/$tileId/settings/': {
      id: '/_secured/campaign/$campaignId/settings/ghost/$tileId/settings/'
      path: '/ghost/$tileId/settings'
      fullPath: '/campaign/$campaignId/settings/ghost/$tileId/settings/'
      preLoaderRoute: typeof SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdSettingsLazyRoute
    }
    '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/settings': {
      id: '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/settings'
      path: '/settings'
      fullPath: '/campaign/$campaignId/settings/omni/$platform/$tileId/settings'
      preLoaderRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute
    }
    '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/import': {
      id: '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/import'
      path: '/import'
      fullPath: '/campaign/$campaignId/settings/omni/$platform/$tileId/import'
      preLoaderRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRouteImport
      parentRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute
    }
  }
}

interface AuthRouteChildren {
  AuthExpiredLinkIndexRoute: typeof AuthExpiredLinkIndexRoute
  AuthLoginAuth0IndexRoute: typeof AuthLoginAuth0IndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthWorkspacesIndexRoute: typeof AuthWorkspacesIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthExpiredLinkIndexRoute: AuthExpiredLinkIndexRoute,
  AuthLoginAuth0IndexRoute: AuthLoginAuth0IndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthWorkspacesIndexRoute: AuthWorkspacesIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface LegalRouteChildren {
  LegalPrivacyPolicyIndexLazyRoute: typeof LegalPrivacyPolicyIndexLazyRoute
}

const LegalRouteChildren: LegalRouteChildren = {
  LegalPrivacyPolicyIndexLazyRoute: LegalPrivacyPolicyIndexLazyRoute,
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

interface SecuredAgencyHubUsersManagementRouteChildren {
  SecuredAgencyHubUsersManagementIndexRoute: typeof SecuredAgencyHubUsersManagementIndexRoute
  SecuredAgencyHubUsersManagementUserIndexRoute: typeof SecuredAgencyHubUsersManagementUserIndexRoute
  SecuredAgencyHubUsersManagementRoleIndexLazyRoute: typeof SecuredAgencyHubUsersManagementRoleIndexLazyRoute
}

const SecuredAgencyHubUsersManagementRouteChildren: SecuredAgencyHubUsersManagementRouteChildren =
  {
    SecuredAgencyHubUsersManagementIndexRoute:
      SecuredAgencyHubUsersManagementIndexRoute,
    SecuredAgencyHubUsersManagementUserIndexRoute:
      SecuredAgencyHubUsersManagementUserIndexRoute,
    SecuredAgencyHubUsersManagementRoleIndexLazyRoute:
      SecuredAgencyHubUsersManagementRoleIndexLazyRoute,
  }

const SecuredAgencyHubUsersManagementRouteWithChildren =
  SecuredAgencyHubUsersManagementRoute._addFileChildren(
    SecuredAgencyHubUsersManagementRouteChildren,
  )

interface SecuredAgencyHubRouteChildren {
  SecuredAgencyHubUsersManagementRoute: typeof SecuredAgencyHubUsersManagementRouteWithChildren
  SecuredAgencyHubIndexLazyRoute: typeof SecuredAgencyHubIndexLazyRoute
  SecuredAgencyHubClientsIndexRoute: typeof SecuredAgencyHubClientsIndexRoute
  SecuredAgencyHubAgencyInfoIndexLazyRoute: typeof SecuredAgencyHubAgencyInfoIndexLazyRoute
}

const SecuredAgencyHubRouteChildren: SecuredAgencyHubRouteChildren = {
  SecuredAgencyHubUsersManagementRoute:
    SecuredAgencyHubUsersManagementRouteWithChildren,
  SecuredAgencyHubIndexLazyRoute: SecuredAgencyHubIndexLazyRoute,
  SecuredAgencyHubClientsIndexRoute: SecuredAgencyHubClientsIndexRoute,
  SecuredAgencyHubAgencyInfoIndexLazyRoute:
    SecuredAgencyHubAgencyInfoIndexLazyRoute,
}

const SecuredAgencyHubRouteWithChildren =
  SecuredAgencyHubRoute._addFileChildren(SecuredAgencyHubRouteChildren)

interface SecuredAiHubRouteChildren {
  SecuredAiHubIndexRoute: typeof SecuredAiHubIndexRoute
  SecuredAiHubChatIdIndexRoute: typeof SecuredAiHubChatIdIndexRoute
}

const SecuredAiHubRouteChildren: SecuredAiHubRouteChildren = {
  SecuredAiHubIndexRoute: SecuredAiHubIndexRoute,
  SecuredAiHubChatIdIndexRoute: SecuredAiHubChatIdIndexRoute,
}

const SecuredAiHubRouteWithChildren = SecuredAiHubRoute._addFileChildren(
  SecuredAiHubRouteChildren,
)

interface SecuredCompanyProfileFlowsRouteChildren {
  SecuredCompanyProfileFlowsIndexLazyRoute: typeof SecuredCompanyProfileFlowsIndexLazyRoute
  SecuredCompanyProfileFlowsNewFlowIndexRoute: typeof SecuredCompanyProfileFlowsNewFlowIndexRoute
  SecuredCompanyProfileFlowsFlowIdIndexLazyRoute: typeof SecuredCompanyProfileFlowsFlowIdIndexLazyRoute
  SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute: typeof SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute
}

const SecuredCompanyProfileFlowsRouteChildren: SecuredCompanyProfileFlowsRouteChildren =
  {
    SecuredCompanyProfileFlowsIndexLazyRoute:
      SecuredCompanyProfileFlowsIndexLazyRoute,
    SecuredCompanyProfileFlowsNewFlowIndexRoute:
      SecuredCompanyProfileFlowsNewFlowIndexRoute,
    SecuredCompanyProfileFlowsFlowIdIndexLazyRoute:
      SecuredCompanyProfileFlowsFlowIdIndexLazyRoute,
    SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute:
      SecuredCompanyProfileFlowsFlowIdUpdateIndexLazyRoute,
  }

const SecuredCompanyProfileFlowsRouteWithChildren =
  SecuredCompanyProfileFlowsRoute._addFileChildren(
    SecuredCompanyProfileFlowsRouteChildren,
  )

interface SecuredCompanyProfileMetricsManagerRouteChildren {
  SecuredCompanyProfileMetricsManagerIndexLazyRoute: typeof SecuredCompanyProfileMetricsManagerIndexLazyRoute
}

const SecuredCompanyProfileMetricsManagerRouteChildren: SecuredCompanyProfileMetricsManagerRouteChildren =
  {
    SecuredCompanyProfileMetricsManagerIndexLazyRoute:
      SecuredCompanyProfileMetricsManagerIndexLazyRoute,
  }

const SecuredCompanyProfileMetricsManagerRouteWithChildren =
  SecuredCompanyProfileMetricsManagerRoute._addFileChildren(
    SecuredCompanyProfileMetricsManagerRouteChildren,
  )

interface SecuredCompanyProfileNamingConventionRouteChildren {
  SecuredCompanyProfileNamingConventionNewRoute: typeof SecuredCompanyProfileNamingConventionNewRoute
  SecuredCompanyProfileNamingConventionIdLazyRoute: typeof SecuredCompanyProfileNamingConventionIdLazyRoute
}

const SecuredCompanyProfileNamingConventionRouteChildren: SecuredCompanyProfileNamingConventionRouteChildren =
  {
    SecuredCompanyProfileNamingConventionNewRoute:
      SecuredCompanyProfileNamingConventionNewRoute,
    SecuredCompanyProfileNamingConventionIdLazyRoute:
      SecuredCompanyProfileNamingConventionIdLazyRoute,
  }

const SecuredCompanyProfileNamingConventionRouteWithChildren =
  SecuredCompanyProfileNamingConventionRoute._addFileChildren(
    SecuredCompanyProfileNamingConventionRouteChildren,
  )

interface SecuredCompanyProfileUserActivitiesRouteChildren {
  SecuredCompanyProfileUserActivitiesIndexRoute: typeof SecuredCompanyProfileUserActivitiesIndexRoute
  SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute: typeof SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute
  SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute: typeof SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute
}

const SecuredCompanyProfileUserActivitiesRouteChildren: SecuredCompanyProfileUserActivitiesRouteChildren =
  {
    SecuredCompanyProfileUserActivitiesIndexRoute:
      SecuredCompanyProfileUserActivitiesIndexRoute,
    SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute:
      SecuredCompanyProfileUserActivitiesActionViewIndexLazyRoute,
    SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute:
      SecuredCompanyProfileUserActivitiesUserViewIndexLazyRoute,
  }

const SecuredCompanyProfileUserActivitiesRouteWithChildren =
  SecuredCompanyProfileUserActivitiesRoute._addFileChildren(
    SecuredCompanyProfileUserActivitiesRouteChildren,
  )

interface SecuredCompanyProfileUsersManagementRouteChildren {
  SecuredCompanyProfileUsersManagementIndexRoute: typeof SecuredCompanyProfileUsersManagementIndexRoute
  SecuredCompanyProfileUsersManagementUserIndexRoute: typeof SecuredCompanyProfileUsersManagementUserIndexRoute
  SecuredCompanyProfileUsersManagementRoleIndexLazyRoute: typeof SecuredCompanyProfileUsersManagementRoleIndexLazyRoute
}

const SecuredCompanyProfileUsersManagementRouteChildren: SecuredCompanyProfileUsersManagementRouteChildren =
  {
    SecuredCompanyProfileUsersManagementIndexRoute:
      SecuredCompanyProfileUsersManagementIndexRoute,
    SecuredCompanyProfileUsersManagementUserIndexRoute:
      SecuredCompanyProfileUsersManagementUserIndexRoute,
    SecuredCompanyProfileUsersManagementRoleIndexLazyRoute:
      SecuredCompanyProfileUsersManagementRoleIndexLazyRoute,
  }

const SecuredCompanyProfileUsersManagementRouteWithChildren =
  SecuredCompanyProfileUsersManagementRoute._addFileChildren(
    SecuredCompanyProfileUsersManagementRouteChildren,
  )

interface SecuredCompanyProfileValuesManagerRouteChildren {
  SecuredCompanyProfileValuesManagerIndexLazyRoute: typeof SecuredCompanyProfileValuesManagerIndexLazyRoute
}

const SecuredCompanyProfileValuesManagerRouteChildren: SecuredCompanyProfileValuesManagerRouteChildren =
  {
    SecuredCompanyProfileValuesManagerIndexLazyRoute:
      SecuredCompanyProfileValuesManagerIndexLazyRoute,
  }

const SecuredCompanyProfileValuesManagerRouteWithChildren =
  SecuredCompanyProfileValuesManagerRoute._addFileChildren(
    SecuredCompanyProfileValuesManagerRouteChildren,
  )

interface SecuredCompanyProfileRouteChildren {
  SecuredCompanyProfileFlowsRoute: typeof SecuredCompanyProfileFlowsRouteWithChildren
  SecuredCompanyProfileImportHubRoute: typeof SecuredCompanyProfileImportHubRoute
  SecuredCompanyProfileIntegrationsRoute: typeof SecuredCompanyProfileIntegrationsRoute
  SecuredCompanyProfileMetricsManagerRoute: typeof SecuredCompanyProfileMetricsManagerRouteWithChildren
  SecuredCompanyProfileNamingConventionRoute: typeof SecuredCompanyProfileNamingConventionRouteWithChildren
  SecuredCompanyProfileUserActivitiesRoute: typeof SecuredCompanyProfileUserActivitiesRouteWithChildren
  SecuredCompanyProfileUsersManagementRoute: typeof SecuredCompanyProfileUsersManagementRouteWithChildren
  SecuredCompanyProfileValuesManagerRoute: typeof SecuredCompanyProfileValuesManagerRouteWithChildren
  SecuredCompanyProfileIndexRoute: typeof SecuredCompanyProfileIndexRoute
  SecuredCompanyProfileAdvertisersIndexRoute: typeof SecuredCompanyProfileAdvertisersIndexRoute
  SecuredCompanyProfileBrandsIndexRoute: typeof SecuredCompanyProfileBrandsIndexRoute
  SecuredCompanyProfileCurrenciesIndexRoute: typeof SecuredCompanyProfileCurrenciesIndexRoute
  SecuredCompanyProfileClientsIndexLazyRoute: typeof SecuredCompanyProfileClientsIndexLazyRoute
  SecuredCompanyProfileCompanyInfoIndexLazyRoute: typeof SecuredCompanyProfileCompanyInfoIndexLazyRoute
}

const SecuredCompanyProfileRouteChildren: SecuredCompanyProfileRouteChildren = {
  SecuredCompanyProfileFlowsRoute: SecuredCompanyProfileFlowsRouteWithChildren,
  SecuredCompanyProfileImportHubRoute: SecuredCompanyProfileImportHubRoute,
  SecuredCompanyProfileIntegrationsRoute:
    SecuredCompanyProfileIntegrationsRoute,
  SecuredCompanyProfileMetricsManagerRoute:
    SecuredCompanyProfileMetricsManagerRouteWithChildren,
  SecuredCompanyProfileNamingConventionRoute:
    SecuredCompanyProfileNamingConventionRouteWithChildren,
  SecuredCompanyProfileUserActivitiesRoute:
    SecuredCompanyProfileUserActivitiesRouteWithChildren,
  SecuredCompanyProfileUsersManagementRoute:
    SecuredCompanyProfileUsersManagementRouteWithChildren,
  SecuredCompanyProfileValuesManagerRoute:
    SecuredCompanyProfileValuesManagerRouteWithChildren,
  SecuredCompanyProfileIndexRoute: SecuredCompanyProfileIndexRoute,
  SecuredCompanyProfileAdvertisersIndexRoute:
    SecuredCompanyProfileAdvertisersIndexRoute,
  SecuredCompanyProfileBrandsIndexRoute: SecuredCompanyProfileBrandsIndexRoute,
  SecuredCompanyProfileCurrenciesIndexRoute:
    SecuredCompanyProfileCurrenciesIndexRoute,
  SecuredCompanyProfileClientsIndexLazyRoute:
    SecuredCompanyProfileClientsIndexLazyRoute,
  SecuredCompanyProfileCompanyInfoIndexLazyRoute:
    SecuredCompanyProfileCompanyInfoIndexLazyRoute,
}

const SecuredCompanyProfileRouteWithChildren =
  SecuredCompanyProfileRoute._addFileChildren(
    SecuredCompanyProfileRouteChildren,
  )

interface SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteChildren {
  SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute
  SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute
  SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute
  SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute
  SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute
}

const SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteChildren: SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteChildren =
  {
    SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute:
      SecuredExternalDataImportHubPerformanceImportsDataFileIdDataAssignmentRoute,
    SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute:
      SecuredExternalDataImportHubPerformanceImportsDataFileIdHeaderSelectionRoute,
    SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute:
      SecuredExternalDataImportHubPerformanceImportsDataFileIdHeadersMappingRoute,
    SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute:
      SecuredExternalDataImportHubPerformanceImportsDataFileIdValidationRoute,
    SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute:
      SecuredExternalDataImportHubPerformanceImportsDataFileIdUploadLazyRoute,
  }

const SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteWithChildren =
  SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute._addFileChildren(
    SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteChildren,
  )

interface SecuredExternalDataImportHubRouteChildren {
  SecuredExternalDataImportHubCustomMetricsRoute: typeof SecuredExternalDataImportHubCustomMetricsRoute
  SecuredExternalDataImportHubWhitelistedEmailsRoute: typeof SecuredExternalDataImportHubWhitelistedEmailsRoute
  SecuredExternalDataImportHubIndexLazyRoute: typeof SecuredExternalDataImportHubIndexLazyRoute
  SecuredExternalDataImportHubPerformanceIndexRoute: typeof SecuredExternalDataImportHubPerformanceIndexRoute
  SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute: typeof SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteWithChildren
  SecuredExternalDataImportHubPerformanceImportsNewRoute: typeof SecuredExternalDataImportHubPerformanceImportsNewRoute
}

const SecuredExternalDataImportHubRouteChildren: SecuredExternalDataImportHubRouteChildren =
  {
    SecuredExternalDataImportHubCustomMetricsRoute:
      SecuredExternalDataImportHubCustomMetricsRoute,
    SecuredExternalDataImportHubWhitelistedEmailsRoute:
      SecuredExternalDataImportHubWhitelistedEmailsRoute,
    SecuredExternalDataImportHubIndexLazyRoute:
      SecuredExternalDataImportHubIndexLazyRoute,
    SecuredExternalDataImportHubPerformanceIndexRoute:
      SecuredExternalDataImportHubPerformanceIndexRoute,
    SecuredExternalDataImportHubPerformanceImportsDataFileIdRoute:
      SecuredExternalDataImportHubPerformanceImportsDataFileIdRouteWithChildren,
    SecuredExternalDataImportHubPerformanceImportsNewRoute:
      SecuredExternalDataImportHubPerformanceImportsNewRoute,
  }

const SecuredExternalDataImportHubRouteWithChildren =
  SecuredExternalDataImportHubRoute._addFileChildren(
    SecuredExternalDataImportHubRouteChildren,
  )

interface SecuredExternalDataIntegrationsIntegrationTabNameRouteChildren {
  SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute
  SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute
}

const SecuredExternalDataIntegrationsIntegrationTabNameRouteChildren: SecuredExternalDataIntegrationsIntegrationTabNameRouteChildren =
  {
    SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute:
      SecuredExternalDataIntegrationsIntegrationTabNameIndexLazyRoute,
    SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute:
      SecuredExternalDataIntegrationsIntegrationTabNameTypeIndexRoute,
  }

const SecuredExternalDataIntegrationsIntegrationTabNameRouteWithChildren =
  SecuredExternalDataIntegrationsIntegrationTabNameRoute._addFileChildren(
    SecuredExternalDataIntegrationsIntegrationTabNameRouteChildren,
  )

interface SecuredExternalDataIntegrationsIntegrationConnectionsRouteChildren {
  SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute
  SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute
}

const SecuredExternalDataIntegrationsIntegrationConnectionsRouteChildren: SecuredExternalDataIntegrationsIntegrationConnectionsRouteChildren =
  {
    SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute:
      SecuredExternalDataIntegrationsIntegrationConnectionsAddRoute,
    SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute:
      SecuredExternalDataIntegrationsIntegrationConnectionsConnectionUpdateRoute,
  }

const SecuredExternalDataIntegrationsIntegrationConnectionsRouteWithChildren =
  SecuredExternalDataIntegrationsIntegrationConnectionsRoute._addFileChildren(
    SecuredExternalDataIntegrationsIntegrationConnectionsRouteChildren,
  )

interface SecuredExternalDataIntegrationsRouteChildren {
  SecuredExternalDataIntegrationsIndexRoute: typeof SecuredExternalDataIntegrationsIndexRoute
  SecuredExternalDataIntegrationsIntegrationTabNameRoute: typeof SecuredExternalDataIntegrationsIntegrationTabNameRouteWithChildren
  SecuredExternalDataIntegrationsIntegrationConnectionsRoute: typeof SecuredExternalDataIntegrationsIntegrationConnectionsRouteWithChildren
  SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute: typeof SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute
}

const SecuredExternalDataIntegrationsRouteChildren: SecuredExternalDataIntegrationsRouteChildren =
  {
    SecuredExternalDataIntegrationsIndexRoute:
      SecuredExternalDataIntegrationsIndexRoute,
    SecuredExternalDataIntegrationsIntegrationTabNameRoute:
      SecuredExternalDataIntegrationsIntegrationTabNameRouteWithChildren,
    SecuredExternalDataIntegrationsIntegrationConnectionsRoute:
      SecuredExternalDataIntegrationsIntegrationConnectionsRouteWithChildren,
    SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute:
      SecuredExternalDataIntegrationsIntegrationSuggestionEmailsRoute,
  }

const SecuredExternalDataIntegrationsRouteWithChildren =
  SecuredExternalDataIntegrationsRoute._addFileChildren(
    SecuredExternalDataIntegrationsRouteChildren,
  )

interface SecuredExternalDataRouteChildren {
  SecuredExternalDataImportHubRoute: typeof SecuredExternalDataImportHubRouteWithChildren
  SecuredExternalDataIntegrationsRoute: typeof SecuredExternalDataIntegrationsRouteWithChildren
  SecuredExternalDataIndexRoute: typeof SecuredExternalDataIndexRoute
}

const SecuredExternalDataRouteChildren: SecuredExternalDataRouteChildren = {
  SecuredExternalDataImportHubRoute:
    SecuredExternalDataImportHubRouteWithChildren,
  SecuredExternalDataIntegrationsRoute:
    SecuredExternalDataIntegrationsRouteWithChildren,
  SecuredExternalDataIndexRoute: SecuredExternalDataIndexRoute,
}

const SecuredExternalDataRouteWithChildren =
  SecuredExternalDataRoute._addFileChildren(SecuredExternalDataRouteChildren)

interface SecuredReportingDashboardsLazyRouteChildren {
  SecuredReportingDashboardsIndexLazyRoute: typeof SecuredReportingDashboardsIndexLazyRoute
  SecuredReportingDashboardsBoardIdIndexRoute: typeof SecuredReportingDashboardsBoardIdIndexRoute
}

const SecuredReportingDashboardsLazyRouteChildren: SecuredReportingDashboardsLazyRouteChildren =
  {
    SecuredReportingDashboardsIndexLazyRoute:
      SecuredReportingDashboardsIndexLazyRoute,
    SecuredReportingDashboardsBoardIdIndexRoute:
      SecuredReportingDashboardsBoardIdIndexRoute,
  }

const SecuredReportingDashboardsLazyRouteWithChildren =
  SecuredReportingDashboardsLazyRoute._addFileChildren(
    SecuredReportingDashboardsLazyRouteChildren,
  )

interface SecuredReportingRouteChildren {
  SecuredReportingDashboardsLazyRoute: typeof SecuredReportingDashboardsLazyRouteWithChildren
  SecuredReportingIndexRoute: typeof SecuredReportingIndexRoute
  SecuredReportingDataExplorationIndexRoute: typeof SecuredReportingDataExplorationIndexRoute
}

const SecuredReportingRouteChildren: SecuredReportingRouteChildren = {
  SecuredReportingDashboardsLazyRoute:
    SecuredReportingDashboardsLazyRouteWithChildren,
  SecuredReportingIndexRoute: SecuredReportingIndexRoute,
  SecuredReportingDataExplorationIndexRoute:
    SecuredReportingDataExplorationIndexRoute,
}

const SecuredReportingRouteWithChildren =
  SecuredReportingRoute._addFileChildren(SecuredReportingRouteChildren)

interface SecuredTestigosRouteChildren {
  SecuredTestigosIndexRoute: typeof SecuredTestigosIndexRoute
}

const SecuredTestigosRouteChildren: SecuredTestigosRouteChildren = {
  SecuredTestigosIndexRoute: SecuredTestigosIndexRoute,
}

const SecuredTestigosRouteWithChildren = SecuredTestigosRoute._addFileChildren(
  SecuredTestigosRouteChildren,
)

interface SecuredCampaignCampaignIdStrategyRouteChildren {
  SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute: typeof SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute
  SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute: typeof SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute
  SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute: typeof SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute
}

const SecuredCampaignCampaignIdStrategyRouteChildren: SecuredCampaignCampaignIdStrategyRouteChildren =
  {
    SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute:
      SecuredCampaignCampaignIdStrategyMediamixMediaMixNameLazyRoute,
    SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute:
      SecuredCampaignCampaignIdStrategyCampaignDescriptionIndexLazyRoute,
    SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute:
      SecuredCampaignCampaignIdStrategyCampaignInfoIndexLazyRoute,
  }

const SecuredCampaignCampaignIdStrategyRouteWithChildren =
  SecuredCampaignCampaignIdStrategyRoute._addFileChildren(
    SecuredCampaignCampaignIdStrategyRouteChildren,
  )

interface SecuredCampaignCampaignIdTraffickingRouteChildren {
  SecuredCampaignCampaignIdTraffickingIndexRoute: typeof SecuredCampaignCampaignIdTraffickingIndexRoute
  SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute: typeof SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute
}

const SecuredCampaignCampaignIdTraffickingRouteChildren: SecuredCampaignCampaignIdTraffickingRouteChildren =
  {
    SecuredCampaignCampaignIdTraffickingIndexRoute:
      SecuredCampaignCampaignIdTraffickingIndexRoute,
    SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute:
      SecuredCampaignCampaignIdTraffickingAnalyticsIndexRoute,
  }

const SecuredCampaignCampaignIdTraffickingRouteWithChildren =
  SecuredCampaignCampaignIdTraffickingRoute._addFileChildren(
    SecuredCampaignCampaignIdTraffickingRouteChildren,
  )

interface SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteChildren {
  SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute
  SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute
}

const SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteChildren: SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteChildren =
  {
    SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute:
      SecuredCampaignCampaignIdSettingsOmniPlatformTileIdImportRoute,
    SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute:
      SecuredCampaignCampaignIdSettingsOmniPlatformTileIdSettingsRoute,
  }

const SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteWithChildren =
  SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute._addFileChildren(
    SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteChildren,
  )

interface SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteChildren {
  SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteWithChildren
}

const SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteChildren: SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteChildren =
  {
    SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRoute:
      SecuredCampaignCampaignIdSettingsOmniPlatformTileIdRouteWithChildren,
  }

const SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteWithChildren =
  SecuredCampaignCampaignIdSettingsOmniPlatformLazyRoute._addFileChildren(
    SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteChildren,
  )

interface SecuredCampaignCampaignIdSettingsLazyRouteChildren {
  SecuredCampaignCampaignIdSettingsIndexRoute: typeof SecuredCampaignCampaignIdSettingsIndexRoute
  SecuredCampaignCampaignIdSettingsOmniPlatformLazyRoute: typeof SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteWithChildren
  SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute: typeof SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute
}

const SecuredCampaignCampaignIdSettingsLazyRouteChildren: SecuredCampaignCampaignIdSettingsLazyRouteChildren =
  {
    SecuredCampaignCampaignIdSettingsIndexRoute:
      SecuredCampaignCampaignIdSettingsIndexRoute,
    SecuredCampaignCampaignIdSettingsOmniPlatformLazyRoute:
      SecuredCampaignCampaignIdSettingsOmniPlatformLazyRouteWithChildren,
    SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute:
      SecuredCampaignCampaignIdSettingsGhostTileIdSettingsIndexRoute,
  }

const SecuredCampaignCampaignIdSettingsLazyRouteWithChildren =
  SecuredCampaignCampaignIdSettingsLazyRoute._addFileChildren(
    SecuredCampaignCampaignIdSettingsLazyRouteChildren,
  )

interface SecuredCampaignCampaignIdPlanningBuyingPlanRouteChildren {
  SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute: typeof SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute
}

const SecuredCampaignCampaignIdPlanningBuyingPlanRouteChildren: SecuredCampaignCampaignIdPlanningBuyingPlanRouteChildren =
  {
    SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute:
      SecuredCampaignCampaignIdPlanningBuyingPlanIndexLazyRoute,
  }

const SecuredCampaignCampaignIdPlanningBuyingPlanRouteWithChildren =
  SecuredCampaignCampaignIdPlanningBuyingPlanRoute._addFileChildren(
    SecuredCampaignCampaignIdPlanningBuyingPlanRouteChildren,
  )

interface SecuredCampaignCampaignIdPlanningInsertionOrdersRouteChildren {
  SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute
  SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute
}

const SecuredCampaignCampaignIdPlanningInsertionOrdersRouteChildren: SecuredCampaignCampaignIdPlanningInsertionOrdersRouteChildren =
  {
    SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute:
      SecuredCampaignCampaignIdPlanningInsertionOrdersIndexLazyRoute,
    SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute:
      SecuredCampaignCampaignIdPlanningInsertionOrdersIdIndexLazyRoute,
  }

const SecuredCampaignCampaignIdPlanningInsertionOrdersRouteWithChildren =
  SecuredCampaignCampaignIdPlanningInsertionOrdersRoute._addFileChildren(
    SecuredCampaignCampaignIdPlanningInsertionOrdersRouteChildren,
  )

interface SecuredCampaignCampaignIdRouteChildren {
  SecuredCampaignCampaignIdStrategyRoute: typeof SecuredCampaignCampaignIdStrategyRouteWithChildren
  SecuredCampaignCampaignIdTraffickingRoute: typeof SecuredCampaignCampaignIdTraffickingRouteWithChildren
  SecuredCampaignCampaignIdSettingsLazyRoute: typeof SecuredCampaignCampaignIdSettingsLazyRouteWithChildren
  SecuredCampaignCampaignIdPlanningBuyingPlanRoute: typeof SecuredCampaignCampaignIdPlanningBuyingPlanRouteWithChildren
  SecuredCampaignCampaignIdPlanningInsertionOrdersRoute: typeof SecuredCampaignCampaignIdPlanningInsertionOrdersRouteWithChildren
  SecuredCampaignCampaignIdPlanningIndexRoute: typeof SecuredCampaignCampaignIdPlanningIndexRoute
}

const SecuredCampaignCampaignIdRouteChildren: SecuredCampaignCampaignIdRouteChildren =
  {
    SecuredCampaignCampaignIdStrategyRoute:
      SecuredCampaignCampaignIdStrategyRouteWithChildren,
    SecuredCampaignCampaignIdTraffickingRoute:
      SecuredCampaignCampaignIdTraffickingRouteWithChildren,
    SecuredCampaignCampaignIdSettingsLazyRoute:
      SecuredCampaignCampaignIdSettingsLazyRouteWithChildren,
    SecuredCampaignCampaignIdPlanningBuyingPlanRoute:
      SecuredCampaignCampaignIdPlanningBuyingPlanRouteWithChildren,
    SecuredCampaignCampaignIdPlanningInsertionOrdersRoute:
      SecuredCampaignCampaignIdPlanningInsertionOrdersRouteWithChildren,
    SecuredCampaignCampaignIdPlanningIndexRoute:
      SecuredCampaignCampaignIdPlanningIndexRoute,
  }

const SecuredCampaignCampaignIdRouteWithChildren =
  SecuredCampaignCampaignIdRoute._addFileChildren(
    SecuredCampaignCampaignIdRouteChildren,
  )

interface SecuredRouteChildren {
  SecuredAgencyHubRoute: typeof SecuredAgencyHubRouteWithChildren
  SecuredAiHubRoute: typeof SecuredAiHubRouteWithChildren
  SecuredCompanyProfileRoute: typeof SecuredCompanyProfileRouteWithChildren
  SecuredExternalDataRoute: typeof SecuredExternalDataRouteWithChildren
  SecuredInsightsRoute: typeof SecuredInsightsRoute
  SecuredReportingRoute: typeof SecuredReportingRouteWithChildren
  SecuredTestigosRoute: typeof SecuredTestigosRouteWithChildren
  SecuredCampaignCampaignIdRoute: typeof SecuredCampaignCampaignIdRouteWithChildren
  SecuredCampaignsIndexRoute: typeof SecuredCampaignsIndexRoute
  SecuredNotificationsIndexRoute: typeof SecuredNotificationsIndexRoute
  SecuredCampaignIndexLazyRoute: typeof SecuredCampaignIndexLazyRoute
}

const SecuredRouteChildren: SecuredRouteChildren = {
  SecuredAgencyHubRoute: SecuredAgencyHubRouteWithChildren,
  SecuredAiHubRoute: SecuredAiHubRouteWithChildren,
  SecuredCompanyProfileRoute: SecuredCompanyProfileRouteWithChildren,
  SecuredExternalDataRoute: SecuredExternalDataRouteWithChildren,
  SecuredInsightsRoute: SecuredInsightsRoute,
  SecuredReportingRoute: SecuredReportingRouteWithChildren,
  SecuredTestigosRoute: SecuredTestigosRouteWithChildren,
  SecuredCampaignCampaignIdRoute: SecuredCampaignCampaignIdRouteWithChildren,
  SecuredCampaignsIndexRoute: SecuredCampaignsIndexRoute,
  SecuredNotificationsIndexRoute: SecuredNotificationsIndexRoute,
  SecuredCampaignIndexLazyRoute: SecuredCampaignIndexLazyRoute,
}

const SecuredRouteWithChildren =
  SecuredRoute._addFileChildren(SecuredRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LegalRoute: LegalRouteWithChildren,
  SecuredRoute: SecuredRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
